<template>
  <div v-if="projectName == 'JXSZJZY'">
    <component :is="jxszContent" ref="jxszContent"></component>
  </div>
  <div v-else-if="NewHomePage">
    <section :style="'background-image: url(' + bannerBgURL + ');height:480px'" class="backgroud-style">
      <div class="container relative-position">
        <div v-if="displayName" class="login-module">
          <div class="login-module-title">登录</div>
          <div class="login-module-content">
            欢迎，{{displayName}}！
          </div>
          <div class="login-btn-row">
            <el-button class="el-button el-button--default login-btn-qyzc" @click="outLogin">退出登录</el-button>
            <el-button style="width:200px;height:48px;" class="el-button k-btn-primary el-button--default" @click="toMGT">进入平台</el-button>
          </div>
        </div>
        <div v-else class="login-module">
          <el-tabs v-model="model.UserTypeId" @tab-click="handleUserTypeSelect">
            <el-tab-pane label="学员" name="3">
              <el-form :model="model" :rules="rules3" ref="loginForm3" class="login-form">
                <el-form-item class="contact-info" prop="UserName3">
                  <el-input class="k-input-2" v-model.trim="model.UserName3" :placeholder="userNamePlaceholder" @keyup.enter.native="login"></el-input>
                </el-form-item>
                <el-form-item class="contact-info" prop="Password3">
                  <el-input v-model.trim="model.Password3" name="password" auto-complete="new-password" :type="loginPasswordType3" @focus="handleLoginPasswordInput3Focus" :placeholder="passwordPlaceholder" @keyup.enter.native="login">
                  </el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="企业" name="2">
              <el-form :model="model" :rules="rules2" ref="loginForm2" class="login-form">
                <el-form-item class="contact-info" prop="UserName2">
                  <el-input class="k-input-2" v-model.trim="model.UserName2" :placeholder="userNamePlaceholder" @keyup.enter.native="login"></el-input>
                </el-form-item>
                <el-form-item class="contact-info" prop="Password2">
                  <el-input v-model.trim="model.Password2" name="password" auto-complete="new-password" :type="loginPasswordType2" @focus="handleLoginPasswordInput2Focus" :placeholder="passwordPlaceholder" @keyup.enter.native="login">
                  </el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="管理员" name="1">
              <el-form :model="model" :rules="rules1" ref="loginForm1" class="login-form">
                <el-form-item class="contact-info" prop="UserName1">
                  <el-input class="k-input-2" v-model.trim="model.UserName1" :placeholder="userNamePlaceholder" @keyup.enter.native="login"></el-input>
                </el-form-item>
                <el-form-item class="contact-info" prop="Password1">
                  <el-input v-model.trim="model.Password1" name="password" auto-complete="new-password" :type="loginPasswordType1" @focus="handleLoginPasswordInput1Focus" :placeholder="passwordPlaceholder" @keyup.enter.native="login">
                  </el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          <div class="login-btn-row">
            <el-button class="el-button el-button--default login-btn-qyzc" @click="register">企业注册</el-button>
            <el-button style="width:200px;height:48px;" class="el-button k-btn-primary el-button--default" @click="login">立即登录</el-button>
          </div>
          <div class="login-wjmm" @click="showForgetPassword">忘记密码</div>
        </div>
      </div>
    </section>
    <section v-show="projectName == 'SRJZY'" class="jfxx-section">
      三类、特种、八大员统一缴费账户：上饶市国控职业培训学校有限公司；账号：159389010000033356；开户行：上饶农村商业银行三清支行；&nbsp;&nbsp;
      <svg t="1691378714099" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4368" width="32" height="32">
        <path d="M0 256h1024v512H0V256z m162.112 155.52V640h37.44V472.96h1.28L315.072 640h36.48V411.52h-37.76v164.8h-1.28L199.552 411.52h-37.44z m234.24 0V640h170.24v-32H433.728V538.88h119.68v-32h-119.68v-63.36h127.36v-32H396.224z m184.64 0L646.528 640h40l44.8-171.84h1.28L777.152 640h39.68l65.92-228.48h-42.24l-42.88 173.76h-1.28l-45.12-173.76h-38.72l-45.12 173.76h-1.28l-42.88-173.76h-42.24z" fill="#ff6715" p-id="4369"></path>
      </svg>
    </section>
    <section v-show="projectName == 'NCJZJY'" class="jfxx-section">
      收款户名：南昌技师学院；账号：1502207029081005612-000000002；银行：中国工商银行股份有限公司南昌胜利支行；缴费群号：522613867&nbsp;&nbsp;
      <svg t="1691378714099" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4368" width="32" height="32">
        <path d="M0 256h1024v512H0V256z m162.112 155.52V640h37.44V472.96h1.28L315.072 640h36.48V411.52h-37.76v164.8h-1.28L199.552 411.52h-37.44z m234.24 0V640h170.24v-32H433.728V538.88h119.68v-32h-119.68v-63.36h127.36v-32H396.224z m184.64 0L646.528 640h40l44.8-171.84h1.28L777.152 640h39.68l65.92-228.48h-42.24l-42.88 173.76h-1.28l-45.12-173.76h-38.72l-45.12 173.76h-1.28l-42.88-173.76h-42.24z" fill="#ff6715" p-id="4369"></path>
      </svg>
    </section>
    <section id="course-page" class="course-page-section">
      <div class="container">
        <h2 class="widget-title text-capitalize">课程报名</h2>
        <div class="genius-post-item">
          <div class="tab-container">
            <div id="tab1" class="pt35">
              <div class="best-course-area">
                <div class="row">
                  <div v-for="item in courses" :key="item.Id" class="col-md-3" :style="item.IsOpen==1?'':'opacity: 1;'" @click="goCourseDetails(item.Id)">
                    <div class="best-course-pic-text relative-position" style="cursor: pointer;">
                      <div class="best-course-pic relative-position">
                        <img :src="item.Pic" alt="">
                        <div class="course-details-btn">
                          <a>进入报名 <i class="fas fa-arrow-right"></i></a>
                        </div>
                        <div class="blakish-overlay"></div>
                        <label v-if="item.IsHot==1" class="item-status-label shz">
                          <i class="iconfont icon-shandian-shi" style="margin-bottom: -4px;"></i>
                          <span>火热报名中</span>
                        </label>
                      </div>
                      <div class="best-course-text">
                        <div class="course-title mb20 headline relative-position">
                          <h3><a>{{item.Name}}</a></h3>
                        </div>
                        <div class="course-meta" v-if="item.ManualUrl && item.IsOpen == 1">
                          <span class="course-category"><a>报名开放</a></span>
                          <span class="course-author" @click="stopPropagation($event)"><a style="color:#17d0cf !important" target="_blank" :href="item.ManualUrl">查看报名流程</a></span>
                        </div>
                        <div class="course-meta" v-else>
                          <span class="course-category"><a>{{item.JobCount}}个岗位</a></span>
                          <span class="course-author"><a>{{item.IsOpen==1?"报名开放":"暂未开放"}}</a></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div><!-- /tab-1 -->
          </div>
        </div>
      </div>
    </section>
    <section v-show="projectName != 'ZJJYJZY'" id="news-section" class="news-section">
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <component :is="newsView" ref="newsView" :is2WM="false"></component>
          </div>
          <div class="col-md-6">
            <component :is="testsView" ref="testsView" :is2WM="false"></component>
          </div>
          <div class="col-md-3">
            <component :is="bwcxnjsmView" ref="bwcxnjsmView" :is2WM="false"></component>
          </div>
        </div>
      </div>
    </section>
    <section v-show="projectName != 'ZJJYJZY'" class="step-section">
      <div class="step-item">
        <div class="step-item-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48" viewBox="0 0 48 48">
            <defs>
              <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#16cfd0" />
                <stop offset="1" stop-color="#04a7fc" />
              </linearGradient>
            </defs>
            <g id="组_565" data-name="组 565" transform="translate(-128 -128)">
              <path id="路径_31" data-name="路径 31" d="M192,130.667v42.667H173.334V130.667H192M194.667,128h-24v48h24V128Z" transform="translate(-40)" fill="url(#linear-gradient)" />
              <path id="路径_32" data-name="路径 32" d="M530.667,386.667v26.667h-16V386.667h16M533.333,384H512v32h21.333V384Z" transform="translate(-360 -240)" fill="url(#linear-gradient)" />
              <path id="路径_33" data-name="路径 33" d="M128,313.333h48V316H128Zm9.333-36H148V280H137.333Zm0,9.333H148v2.667H137.333Zm21.333,8h8v2.667h-8Z" transform="translate(0 -140)" fill="url(#linear-gradient)" />
            </g>
          </svg>
        </div>
        <div class="step-item-text">1.企业注册</div>
      </div>
      <div class="step-item">
        <div class="step-item-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48" viewBox="0 0 48 48">
            <defs>
              <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#16cfd0" />
                <stop offset="1" stop-color="#04a7fc" />
              </linearGradient>
            </defs>
            <path id="路径_37" data-name="路径 37" d="M46.85,37.49H39.994V30.632a1.718,1.718,0,0,0-1.714-1.714,1.619,1.619,0,0,0-1.714,1.714V37.49H29.708A1.718,1.718,0,0,0,27.993,39.2a1.619,1.619,0,0,0,1.714,1.714h6.857v6.857a1.718,1.718,0,0,0,1.714,1.714,1.62,1.62,0,0,0,1.714-1.714V40.918h6.857A1.718,1.718,0,0,0,48.565,39.2,1.62,1.62,0,0,0,46.85,37.49ZM38.279,15.2a13.714,13.714,0,1,0-27.428,0,13.543,13.543,0,0,0,6.171,11.485A23.89,23.89,0,0,0,.565,49.49H3.993A20.632,20.632,0,0,1,24.565,28.918,13.754,13.754,0,0,0,38.279,15.2ZM24.565,25.49A10.286,10.286,0,1,1,34.85,15.2,10.316,10.316,0,0,1,24.565,25.49Zm0,0" transform="translate(-0.565 -1.49)" fill="url(#linear-gradient)" />
          </svg>

        </div>
        <div class="step-item-text">2.添加学员</div>
      </div>
      <div class="step-item">
        <div class="step-item-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48" viewBox="0 0 48 48">
            <defs>
              <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#16cfd0" />
                <stop offset="1" stop-color="#04a7fc" />
              </linearGradient>
            </defs>
            <g id="组_564" data-name="组 564" transform="translate(-125.041 -65.1)">
              <path id="路径_29" data-name="路径 29" d="M162.209,102.363a1.815,1.815,0,0,0-.018-2.555,18.989,18.989,0,0,0-7.489-4.634c-.114-.036-.234-.078-.353-.114a16.462,16.462,0,0,0,3.032-2.4,16.213,16.213,0,0,0,0-22.838,15.991,15.991,0,0,0-22.7.006,16.221,16.221,0,0,0-2.486,19.608,1.792,1.792,0,0,0,2.462.639,1.814,1.814,0,0,0,.635-2.477,12.448,12.448,0,1,1,10.743,6.182,1.722,1.722,0,0,0-.725.157,19.827,19.827,0,0,0-6.171,1.157,18.889,18.889,0,0,0-5.716,3.35c-3.157,2.669-5.848,6.526-8.22,11.8a1.816,1.816,0,0,0,.893,2.392,1.788,1.788,0,0,0,2.379-.9c4.422-9.81,9.838-14.191,17.555-14.191,6.051,0,10.257,1.494,13.636,4.845A1.8,1.8,0,0,0,162.209,102.363Z" transform="translate(0 0)" fill="url(#linear-gradient)" />
              <path id="路径_30" data-name="路径 30" d="M614.924,533.275a1.8,1.8,0,0,0-2.474.581l-8.909,14.349-4.607-3.817a1.8,1.8,0,1,0-2.289,2.768l6.2,5.129a1.79,1.79,0,0,0,1.144.413,1.557,1.557,0,0,0,.288-.024,1.8,1.8,0,0,0,1.24-.827l9.994-16.1A1.8,1.8,0,0,0,614.924,533.275Z" transform="translate(-442.733 -439.599)" fill="url(#linear-gradient)" />
            </g>
          </svg>

        </div>
        <div class="step-item-text">3.课程报名</div>
      </div>
      <div class="step-item">
        <div class="step-item-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="48" viewBox="0 0 48 48">
            <defs>
              <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#16cfd0" />
                <stop offset="1" stop-color="#04a7fc" />
              </linearGradient>
            </defs>
            <g id="组_563" data-name="组 563" transform="translate(-58.514 -58.514)">
              <path id="路径_27" data-name="路径 27" d="M82.514,58.514a24,24,0,0,0-24,24,26.48,26.48,0,0,0,.774,6.194,1.444,1.444,0,1,0,2.806-.677,20.3,20.3,0,0,1-.677-5.419,21.039,21.039,0,1,1,7.161,15.774,1.439,1.439,0,1,0-1.935,2.129,24,24,0,1,0,15.871-42Z" transform="translate(0 0)" fill="url(#linear-gradient)" />
              <path id="路径_28" data-name="路径 28" d="M104.835,280.012a1.45,1.45,0,0,0-2.613,1.258,21.908,21.908,0,0,0,2.516,4.065,1.38,1.38,0,0,0,1.161.581,1.561,1.561,0,0,0,.871-.29,1.414,1.414,0,0,0,.29-2.032,27.538,27.538,0,0,1-2.226-3.581Zm10.355-4.742a1.258,1.258,0,0,0,0,2.516h6.968v5.129a1.742,1.742,0,1,0,3.484,0v-5.129h6.968a1.258,1.258,0,0,0,0-2.516h-6.968v-3.677h6.968a1.258,1.258,0,0,0,0-2.516H127l5.806-10.161a1.213,1.213,0,0,0-2.129-1.161l-6.29,11.032a.355.355,0,0,0-.1.29h-.581c0-.1-.1-.194-.1-.29l-6.29-11.032a1.213,1.213,0,0,0-2.129,1.161L121,269.077h-5.71a1.258,1.258,0,1,0,0,2.516h6.968v3.677H115.19Z" transform="translate(-41.289 -188.111)" fill="url(#linear-gradient)" />
            </g>
          </svg>
        </div>
        <div class="step-item-text">4.缴纳学费</div>
      </div>
      <div class="step-item">
        <div class="step-item-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47.998" height="48" viewBox="0 0 47.998 48">
            <defs>
              <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#16cfd0" />
                <stop offset="1" stop-color="#04a7fc" />
              </linearGradient>
            </defs>
            <path id="路径_26" data-name="路径 26" d="M48.886,51.265c-.261-.1-6.048-2.028-19.641,3.542a27.394,27.394,0,0,1,17.718-7.433,1.044,1.044,0,0,0,.986-1.1,1.023,1.023,0,0,0-1.1-.986,29.408,29.408,0,0,0-18.365,7.322c2.216-3.68,6.875-8.368,16.6-10.62a1.045,1.045,0,1,0-.474-2.036c-12.434,2.882-17.229,9.588-19.061,13.825-1.832-4.237-6.626-10.943-19.061-13.825a1.045,1.045,0,0,0-.47,2.036c9.722,2.253,14.379,6.942,16.6,10.622A29.42,29.42,0,0,0,4.246,45.29a1.022,1.022,0,0,0-1.1.986,1.04,1.04,0,0,0,.984,1.1,27.392,27.392,0,0,1,17.843,7.55C8.2,49.2,2.508,51.173,2.254,51.267a1.044,1.044,0,0,0-.672,1.071L4.1,80.6a1.044,1.044,0,0,0,1.04.952h.017c10.617-.159,19.612,6.117,19.7,6.18.019.015.046.008.067.021s.036.044.063.058a1.05,1.05,0,0,0,.956,0c.025-.013.036-.04.058-.054s.048-.008.069-.021c.088-.063,8.861-6.188,19.372-6.188.15,0,.23.01.459,0a1.044,1.044,0,0,0,1.04-.948L49.57,52.343a1.044,1.044,0,0,0-.685-1.078Zm-45.143,1.8c2.068-.3,8.437-.472,20.679,5.2V84.978A38.49,38.49,0,0,0,6.1,79.467l-2.354-26.4Zm41.206,26.4A39,39,0,0,0,26.51,84.989V58.268c12.276-5.687,18.783-5.505,20.894-5.2Z" transform="translate(-1.577 -39.929)" fill="url(#linear-gradient)" />
          </svg>

        </div>
        <div class="step-item-text">5.在线学习</div>
      </div>
      <div class="step-item">
        <div class="step-item-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56" height="48" viewBox="0 0 56 48">
            <defs>
              <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#16cfd0" />
                <stop offset="1" stop-color="#04a7fc" />
              </linearGradient>
            </defs>
            <g id="组_566" data-name="组 566" transform="translate(0 -64)">
              <path id="路径_34" data-name="路径 34" d="M231.324,263.19,236.5,259.5l5.177,3.694c.407.29.924-.059.924-.624V233.309a2.706,2.706,0,0,0-2.44-2.909h-7.32a2.706,2.706,0,0,0-2.44,2.909v29.258C230.4,263.131,230.917,263.48,231.324,263.19Zm2.737-29.882h4.88a1.352,1.352,0,0,1,1.22,1.454V259.2l-3.66-2.611-3.66,2.611V234.763A1.353,1.353,0,0,1,234.06,233.309Z" transform="translate(-217.26 -158.47)" fill="url(#linear-gradient)" />
              <path id="路径_35" data-name="路径 35" d="M54.6,81.829a1.372,1.372,0,1,0,0-2.743c-3.163,0-5.736-2.248-5.736-5.011V71.753c0-2.763,2.573-5.011,5.736-5.011A1.372,1.372,0,1,0,54.6,64H6.591C2.957,64,0,66.7,0,70.013v5.8a5.817,5.817,0,0,0,2.406,4.642A5.818,5.818,0,0,0,0,85.1v5.8a5.817,5.817,0,0,0,2.406,4.642A5.818,5.818,0,0,0,0,100.185v5.8C0,109.3,2.957,112,6.591,112H54.6a1.372,1.372,0,1,0,0-2.743c-3.163,0-5.736-2.248-5.736-5.011v-2.32c0-2.763,2.573-5.011,5.736-5.011a1.372,1.372,0,1,0,0-2.743c-3.163,0-5.736-2.248-5.736-5.011V86.84C48.864,84.076,51.437,81.829,54.6,81.829ZM48.091,94.171H29.4A1.386,1.386,0,0,0,28,95.543h0a1.386,1.386,0,0,0,1.4,1.371H48.091a7.314,7.314,0,0,0-2.027,5.011v2.32a7.316,7.316,0,0,0,2.027,5.011H6.591a3.563,3.563,0,0,1-3.791-3.27v-5.8a3.564,3.564,0,0,1,3.791-3.271H9.8a1.386,1.386,0,0,0,1.4-1.371h0a1.386,1.386,0,0,0-1.4-1.371H6.591A3.563,3.563,0,0,1,2.8,90.9V85.1a3.564,3.564,0,0,1,3.791-3.271H9.8a1.386,1.386,0,0,0,1.4-1.371h0a1.386,1.386,0,0,0-1.4-1.371H6.591A3.563,3.563,0,0,1,2.8,75.816v-5.8a3.563,3.563,0,0,1,3.791-3.27h41.5a7.316,7.316,0,0,0-2.027,5.011v2.321a7.316,7.316,0,0,0,2.027,5.011H29.4A1.386,1.386,0,0,0,28,80.458h0a1.386,1.386,0,0,0,1.4,1.371H48.091a7.314,7.314,0,0,0-2.027,5.011v2.32A7.316,7.316,0,0,0,48.091,94.171Z" fill="url(#linear-gradient)" />
            </g>
          </svg>

        </div>
        <div class="step-item-text">6.模拟练习</div>
      </div>
      <div class="step-item">
        <div class="step-item-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="57.264" height="48" viewBox="0 0 57.264 48">
            <defs>
              <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#16cfd0" />
                <stop offset="1" stop-color="#04a7fc" />
              </linearGradient>
            </defs>
            <g id="组_562" data-name="组 562" transform="translate(-19 -91.5)">
              <path id="路径_24" data-name="路径 24" d="M38.863,114.006a11.253,11.253,0,1,1,11.25-11.256A11.262,11.262,0,0,1,38.863,114.006Zm0-20.2a8.95,8.95,0,1,0,8.947,8.953A8.956,8.956,0,0,0,38.863,93.8Zm6.84,45.7a6.374,6.374,0,0,1-1.514-.184l-15.873-3.886a1.153,1.153,0,0,1-.812-1.508l2.706-7.56a1.15,1.15,0,0,1,1.411-.714l8.5,2.51v-8.072a4.543,4.543,0,0,1,1.71-3.506,6.208,6.208,0,0,1,7.738,0,4.544,4.544,0,0,1,1.71,3.506c0,.035.006,3.8-.012,7.583-.04,7.842-.138,8.124-.23,8.394a4.922,4.922,0,0,1-2.1,2.545A6.235,6.235,0,0,1,45.7,139.5Zm-15.6-6,14.63,3.581a4.193,4.193,0,0,0,.967.115,3.286,3.286,0,0,0,3.126-1.819c.121-1.146.155-9.92.144-15.3,0-1.411-1.468-2.556-3.27-2.556s-3.27,1.146-3.27,2.556V129.7a1.151,1.151,0,0,1-1.474,1.105l-8.947-2.631Zm-8.2,2.879a1.215,1.215,0,0,1-.426-.081,1.148,1.148,0,0,1-.639-1.5l4.807-12.027a1.151,1.151,0,1,1,2.136.858l-4.807,12.022A1.149,1.149,0,0,1,21.908,136.379Zm10.271,2.879H20.151a1.151,1.151,0,0,1,0-2.3H32.179a1.151,1.151,0,0,1,0,2.3ZM55.7,136.621a1.151,1.151,0,1,1,0-2.3,18.257,18.257,0,0,0,0-36.514,1.151,1.151,0,0,1,0-2.3,20.56,20.56,0,1,1,0,41.12Z" fill="url(#linear-gradient)" />
              <path id="路径_25" data-name="路径 25" d="M674.823,296.99h-9.8a1.129,1.129,0,0,1-1.126-1.126V282.126a1.126,1.126,0,0,1,2.252,0v12.612h8.671a1.126,1.126,0,1,1,0,2.252Z" transform="translate(-607.326 -178.465)" fill="url(#linear-gradient)" />
            </g>
          </svg>

        </div>
        <div class="step-item-text">7.上机测试</div>
      </div>
      <div class="step-item">
        <div class="step-item-icon">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="49.823" height="48" viewBox="0 0 49.823 48">
            <defs>
              <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#16cfd0" />
                <stop offset="1" stop-color="#04a7fc" />
              </linearGradient>
            </defs>
            <path id="路径_36" data-name="路径 36" d="M71.886,86.793a.356.356,0,0,1-.213-.07L65.132,81.9l-6.586,4.812a.359.359,0,0,1-.571-.29V76.7a.358.358,0,0,1,.472-.341l2.326.77a.363.363,0,0,1,.264.345V81.1l3.89-2.841a.359.359,0,0,1,.425,0l3.829,2.822v-3.6a.359.359,0,0,1,.242-.339l2.345-.81a.359.359,0,0,1,.476.339v9.767a.359.359,0,0,1-.2.321.353.353,0,0,1-.161.039ZM31.152,85.116a5.547,5.547,0,0,1-5.54-5.541V44.334a5.547,5.547,0,0,1,5.54-5.541H61.894a5.548,5.548,0,0,1,5.542,5.541V55.328a.359.359,0,0,1-.359.359H64.793a.359.359,0,0,1-.359-.359V44.334a2.543,2.543,0,0,0-2.54-2.54H31.153a2.543,2.543,0,0,0-2.54,2.54V79.575a2.543,2.543,0,0,0,2.54,2.54H55.024a.359.359,0,0,1,.359.359v2.284a.359.359,0,0,1-.359.359H31.152ZM65.109,77.47A10.324,10.324,0,1,1,75.435,67.146,10.336,10.336,0,0,1,65.109,77.47Zm0-17.586a7.262,7.262,0,1,0,7.262,7.262A7.27,7.27,0,0,0,65.109,59.884ZM34.137,75.449a.359.359,0,0,1-.359-.359v-2.5a.359.359,0,0,1,.359-.359H52.214a.359.359,0,0,1,.359.359v2.5a.359.359,0,0,1-.359.359Zm30.974-3.841a4.463,4.463,0,1,1,4.463-4.463A4.468,4.468,0,0,1,65.111,71.608Zm0-7.035a2.573,2.573,0,1,0,2.572,2.573A2.575,2.575,0,0,0,65.111,64.573ZM34.137,67.5a.359.359,0,0,1-.359-.359v-2.5a.359.359,0,0,1,.359-.359H52.214a.359.359,0,0,1,.359.359v2.5a.359.359,0,0,1-.359.359Zm0-7.881a.359.359,0,0,1-.359-.359v-2.5a.359.359,0,0,1,.359-.359H52.214a.359.359,0,0,1,.359.359v2.5a.359.359,0,0,1-.359.359Zm0-7.946a.359.359,0,0,1-.359-.359v-2.5a.359.359,0,0,1,.359-.359H58.911a.359.359,0,0,1,.359.359v2.5a.359.359,0,0,1-.359.359Z" transform="translate(-25.612 -38.793)" fill="url(#linear-gradient)" />
          </svg>

        </div>
        <div class="step-item-text">8.领取证书</div>
      </div>
    </section>
    <section v-show="projectName != 'ZJJYJZY'" id='superiority-section' class="superiority-section jarallax">
      <div class="superiority-title">选择我们的理由及平台优势</div>
      <div class="superiority-content">
        <div class="superiority-row">
          <div class="superiority-item">
            <div class="superiority-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56" height="56" viewBox="0 0 56 56">
                <defs>
                  <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="#16cfd0" />
                    <stop offset="1" stop-color="#04a7fc" />
                  </linearGradient>
                </defs>
                <g id="组_580" data-name="组 580" transform="translate(-75.977 -70.269)">
                  <path id="路径_39" data-name="路径 39" d="M101.544,71.183a4.326,4.326,0,0,1,2.735-.913,4.209,4.209,0,0,1,2.121.539,7.973,7.973,0,0,1,.912.621q11.415,8.311,22.824,16.622a4.382,4.382,0,0,1,1.507,1.883,4.487,4.487,0,0,1-.57,4.4,4.261,4.261,0,0,1-2.267,1.566,6.089,6.089,0,0,1-1.007.177q.009,10.679,0,21.351a4.426,4.426,0,0,1,.525,8.761,8.789,8.789,0,0,1-1.633.076H80.373a4.423,4.423,0,0,1-2.691-7.912,4.5,4.5,0,0,1,3.014-.932q.01-10.679,0-21.351a4.4,4.4,0,0,1-4.172-4.26,4.343,4.343,0,0,1,1.741-3.69q11.662-8.463,23.279-16.939m2.013,12.235a2.926,2.926,0,0,0-2.222,1.623c-.728,1.54-1.443,3.081-2.172,4.621a1.419,1.419,0,0,1-.355.076c-1.475.222-2.95.45-4.419.672a2.96,2.96,0,0,0-1.627,5.008c1.013,1.046,2.039,2.086,3.052,3.132a3.3,3.3,0,0,1,.449.494c-.26,1.636-.532,3.271-.8,4.907a3.276,3.276,0,0,0,.025,1.445,2.973,2.973,0,0,0,1.437,1.838,3.005,3.005,0,0,0,2.184.26,6.994,6.994,0,0,0,1.437-.7l3.311-1.832c.057-.025.127-.089.19-.044q2.1,1.16,4.191,2.32a2.95,2.95,0,0,0,4.343-2.5,8.052,8.052,0,0,0-.177-1.452c-.228-1.426-.475-2.853-.69-4.285,1.051-1.071,2.1-2.149,3.147-3.227a5.115,5.115,0,0,0,.785-.913,2.963,2.963,0,0,0-1.317-4.247,5.392,5.392,0,0,0-1.456-.323c-1.342-.209-2.691-.406-4.039-.621a7.958,7.958,0,0,1-.367-.735c-.525-1.116-1.051-2.238-1.576-3.354a4.758,4.758,0,0,0-.627-1.122,2.966,2.966,0,0,0-2.71-1.04m-13.15,31.215a1.47,1.47,0,0,0-.962.723,1.5,1.5,0,0,0,.025,1.477,1.451,1.451,0,0,0,.975.685,3.165,3.165,0,0,0,.6.025h26.2a1.464,1.464,0,0,0,.975-.374,1.485,1.485,0,0,0,.462-1.369,1.458,1.458,0,0,0-.9-1.1,2.606,2.606,0,0,0-1.038-.1H90.711a1.238,1.238,0,0,0-.3.032Z" transform="translate(0 0)" fill="url(#linear-gradient)" />
                  <path id="路径_40" data-name="路径 40" d="M380.774,330.4c.962-1.988,1.874-4.008,2.836-6q1.311,2.782,2.615,5.571a3.529,3.529,0,0,0,.2.411c.614.12,1.241.2,1.861.3,1.475.228,2.95.45,4.425.677-1.507,1.564-3.033,3.115-4.552,4.672q.541,3.3,1.07,6.584c-1.88-1.013-3.735-2.07-5.616-3.09a2.437,2.437,0,0,0-.462.234c-1.728.95-3.444,1.918-5.179,2.849.342-2.2.722-4.387,1.064-6.584-1.507-1.564-3.033-3.109-4.539-4.666,1.494-.241,2.988-.456,4.482-.69C379.578,330.579,380.173,330.472,380.774,330.4Z" transform="translate(-279.623 -238.011)" fill="url(#linear-gradient)" />
                </g>
              </svg>

            </div>
            <div>
              <div class="superiority-subtitle">官方权威的培训机构</div>
              <div class="superiority-desc">隶属于南昌市城乡建设委员会，同时被劳动部门授予职业技能鉴定站。建设部门、人事部门授予建设类培训基地，是全省建设行业职业培训机构之一。</div>
            </div>
          </div>
          <div class="superiority-item">
            <div class="superiority-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56" height="54.569" viewBox="0 0 56 54.569">
                <defs>
                  <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="#16cfd0" />
                    <stop offset="1" stop-color="#04a7fc" />
                  </linearGradient>
                </defs>
                <g id="组_586" data-name="组 586" transform="translate(-74.2 -81.1)">
                  <path id="路径_41" data-name="路径 41" d="M89.877,81.1H114.54c.348.082.709.057,1.057.133a6.912,6.912,0,0,1,4.673,3.261,7.689,7.689,0,0,1,1.108,3.825c.019,1.051-.013,2.1.013,3.153.469-.013.937,0,1.406-.006a7.341,7.341,0,0,1,7.231,5.667c-.88.532-1.741,1.083-2.634,1.589q-7.123,4.113-14.253,8.232a12.77,12.77,0,0,0-12.689-6.028,12.673,12.673,0,0,0-7.256,3.616,12.483,12.483,0,0,0-1.855,2.343q-7.361-4.246-14.722-8.5c-.735-.437-1.456-.886-2.191-1.33a7.392,7.392,0,0,1,2.431-3.882,7.316,7.316,0,0,1,4.667-1.71h1.532c.006-1.057,0-2.109.006-3.16a7.571,7.571,0,0,1,2.064-5.059,6.731,6.731,0,0,1,4.2-2.077,2.623,2.623,0,0,0,.551-.07m-2.754,4.337a4.662,4.662,0,0,0-1.114,3.141c.006.962-.006,1.931.006,2.894q16.213-.009,32.42,0c.006-1.013.006-2.02,0-3.033a4.66,4.66,0,0,0-1.361-3.261,3.739,3.739,0,0,0-2.672-1.1H90A3.825,3.825,0,0,0,87.123,85.437Zm-12.9,14.944c.437.272.88.538,1.33.791q7.256,4.189,14.519,8.384a12.834,12.834,0,0,0-.6,3.16c-.006.5,0,1.007-.006,1.513Q83.336,110.7,77.2,107.144c-1.007-.57-1.976-1.2-2.957-1.8C74.2,103.693,74.231,102.034,74.225,100.381Zm50.77,3.141c1.741-1.019,3.5-1.995,5.224-3.039v5.053q-7.655,4.4-15.285,8.814a1.473,1.473,0,0,0,.07-.576,13.18,13.18,0,0,0-.6-4.147c3.527-2.026,7.054-4.071,10.587-6.1Z" transform="translate(-0.018)" fill="url(#linear-gradient)" />
                  <path id="路径_42" data-name="路径 42" d="M370.116,438.951a9.82,9.82,0,0,1,11.024,8.181,9.548,9.548,0,0,1-.469,4.787,5.959,5.959,0,0,1-.7,1.627,9.817,9.817,0,0,1-17.679-1.33c-.108-.481-.291-.937-.4-1.418a9.662,9.662,0,0,1,.8-6.579,9.844,9.844,0,0,1,7.415-5.268m.456,3.894a5.9,5.9,0,1,0,3.343.475A5.953,5.953,0,0,0,370.571,442.845Z" transform="translate(-269.245 -335.107)" fill="url(#linear-gradient)" />
                  <path id="路径_43" data-name="路径 43" d="M74.2,518.6c1.127.709,2.3,1.342,3.445,2.02q5.471,3.153,10.942,6.319c.551.336,1.133.627,1.672.981a15.627,15.627,0,0,0,1.007,2.039,12.78,12.78,0,0,0,13.386,5.939,12.7,12.7,0,0,0,6.243-3.179,13.129,13.129,0,0,0,3.2-4.673c.747-.469,1.526-.886,2.286-1.336q6.905-3.989,13.816-7.978v19.256a7.27,7.27,0,0,1-1.279,4.28,7.371,7.371,0,0,1-5.87,3.2H81.311a7.255,7.255,0,0,1-4.084-1.406,7.382,7.382,0,0,1-3.027-5.807Q74.2,528.434,74.2,518.6Z" transform="translate(0 -409.797)" fill="url(#linear-gradient)" />
                  <path id="路径_44" data-name="路径 44" d="M472.387,547.35a2.884,2.884,0,0,1,1.735.291,2.942,2.942,0,1,1-3.255,4.844,2.941,2.941,0,0,1,1.52-5.135Z" transform="translate(-370.599 -436.699)" fill="url(#linear-gradient)" />
                </g>
              </svg>
            </div>
            <div>
              <div class="superiority-subtitle">“一次不跑”的贴心服务</div>
              <div class="superiority-desc">按照“应上尽上”原则，将所有服务事项部署上网。从注册、报名、缴费，到学习、练习、打印证明全部上网。大大提升企业办事效率，降低经营成本。</div>
            </div>
          </div>
          <div class="superiority-item">
            <div class="superiority-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56" height="61.316" viewBox="0 0 56 61.316">
                <defs>
                  <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="#16cfd0" />
                    <stop offset="1" stop-color="#04a7fc" />
                  </linearGradient>
                </defs>
                <path id="路径_45" data-name="路径 45" d="M203.895,128.936l-1.044-.411-10.2-2.722c-1.941-.507-3.18.2-3.692,2.115l-12.144,50.477c-.512,1.967.192,3.205,2.135,3.738l10.2,2.719c1.968.534,3.21-.195,3.72-2.163l12.147-50.448c.414-1.553.047-2.647-1.117-3.3ZM198.94,146.5a2.268,2.268,0,0,1-.725,1.165,1.14,1.14,0,0,1-.99.268h-.083l-9.253-2.5a1.062,1.062,0,0,1-.75-.752,1.908,1.908,0,0,1-.145-.652,2.2,2.2,0,0,1,.069-.688,1.9,1.9,0,0,1,.729-1.118,1.048,1.048,0,0,1,1.046-.313l9.252,2.5h.047a1.029,1.029,0,0,1,.162.107,1.318,1.318,0,0,1,.568.669,1.708,1.708,0,0,1,.146.62,2.349,2.349,0,0,1-.075.691Zm1.561-6.1a1.849,1.849,0,0,1-.529,1.243,1.92,1.92,0,0,1-.254.27,1.2,1.2,0,0,1-.3.182.969.969,0,0,1-.67.133h-.05l-9.251-2.477a1.3,1.3,0,0,1-.8-.8,1.888,1.888,0,0,1-.093-.927,2.71,2.71,0,0,1,.047-.386,2.949,2.949,0,0,1,.168-.371,2.086,2.086,0,0,1,.561-.77,1.065,1.065,0,0,1,1.068-.264l9.253,2.476h.046a1.121,1.121,0,0,1,.5.432,1.492,1.492,0,0,1,.346.961,1.868,1.868,0,0,1-.039.3Zm17.246-9.642a4.063,4.063,0,0,0-.292,1.6V184.7a3.925,3.925,0,0,0,.292,1.605c.216.431.485.652.8.652s.563-.22.78-.652a3.573,3.573,0,0,0,.338-1.605v-52.35a3.7,3.7,0,0,0-.338-1.6c-.218-.44-.46-.658-.78-.658s-.581.216-.8.658Zm-1.339,1.6a4.074,4.074,0,0,0-.291-1.6c-.241-.437-.51-.654-.826-.654s-.555.218-.777.654a3.751,3.751,0,0,0-.336,1.6V184.7a3.591,3.591,0,0,0,.336,1.6c.223.436.463.654.777.654s.585-.219.826-.654a3.907,3.907,0,0,0,.291-1.6v-52.35Zm14.33-1.6a4.064,4.064,0,0,0-.29,1.6V184.7a3.946,3.946,0,0,0,.289,1.605c.219.431.486.652.8.652s.565-.22.781-.652a3.588,3.588,0,0,0,.336-1.605v-52.35a3.732,3.732,0,0,0-.336-1.6c-.217-.44-.459-.658-.781-.658s-.58.217-.8.658Zm-1.336,1.6a4.034,4.034,0,0,0-.293-1.6c-.241-.437-.51-.654-.825-.654s-.557.218-.779.654a3.759,3.759,0,0,0-.337,1.6V184.7a3.606,3.606,0,0,0,.337,1.6c.222.436.464.654.779.654s.584-.219.825-.654a3.869,3.869,0,0,0,.293-1.6v-52.35Zm-17.8-1.992a2.311,2.311,0,0,0-3.228,0,2.178,2.178,0,0,0-.655,1.6v52.714a2.177,2.177,0,0,0,.655,1.6,2.258,2.258,0,0,0,3.228,0,2.178,2.178,0,0,0,.658-1.6V131.965a2.179,2.179,0,0,0-.658-1.6Zm10.249,0a2.193,2.193,0,0,0-.655,1.6v52.714a2.271,2.271,0,1,0,4.541,0V131.965a2.193,2.193,0,0,0-.654-1.6,2.315,2.315,0,0,0-3.231,0Z" transform="translate(-176.652 -125.644)" fill="url(#linear-gradient)" />
              </svg>
            </div>
            <div>
              <div class="superiority-subtitle">高质高量的教学内容</div>
              <div class="superiority-desc">平台具有丰富的面向不同课程和岗位的教学视频课件。聘请行业内资深专家、教授进行授课和录制。教学内容按照住建部的要求每年定期更新。</div>
            </div>
          </div>

          <div class="superiority-item">
            <div class="superiority-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56" height="64.614" viewBox="0 0 56 64.614">
                <defs>
                  <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="#16cfd0" />
                    <stop offset="1" stop-color="#04a7fc" />
                  </linearGradient>
                </defs>
                <g id="组_587" data-name="组 587" transform="translate(-96 -32.017)">
                  <path id="路径_47" data-name="路径 47" d="M225.145,556.783l-10.733-6.108a2.154,2.154,0,0,0-2.132,3.743l10.733,6.108a2.154,2.154,0,1,0,2.132-3.743Z" transform="translate(-107.438 -483.484)" fill="url(#linear-gradient)" />
                  <path id="路径_48" data-name="路径 48" d="M250.164,324a2.154,2.154,0,1,0-2.128-3.746l-16.813,9.57-16.811-9.567A2.154,2.154,0,1,0,212.28,324l17.052,9.7V354.44a2.154,2.154,0,1,0,4.308,0V333.621c0-.067-.032-.125-.039-.192Z" transform="translate(-107.438 -268.578)" fill="url(#linear-gradient)" />
                  <path id="路径_49" data-name="路径 49" d="M148.789,45.51,127.244,32.9a6.438,6.438,0,0,0-6.5,0L99.209,45.51A6.5,6.5,0,0,0,96,51.125V77.891a6.5,6.5,0,0,0,3.28,5.654l21.538,12.245a6.429,6.429,0,0,0,6.36,0l21.538-12.245A6.5,6.5,0,0,0,152,77.891V51.125a6.5,6.5,0,0,0-3.211-5.615Zm-1.1,32.381a2.166,2.166,0,0,1-1.094,1.885L125.06,92.02a2.139,2.139,0,0,1-2.119,0L101.4,79.775a2.167,2.167,0,0,1-1.094-1.885V51.125a2.166,2.166,0,0,1,1.07-1.872l21.53-12.611a2.143,2.143,0,0,1,2.167,0l21.547,12.613a2.16,2.16,0,0,1,1.07,1.87Z" fill="url(#linear-gradient)" />
                  <path id="路径_50" data-name="路径 50" d="M604.534,448.394l-10.052,5.932a5.322,5.322,0,0,0-2.513,4.026v11.874c0,1.4,1.124,1.878,2.513,1.06l10.052-5.932a5.322,5.322,0,0,0,2.514-4.026V449.454C607.047,448.049,605.923,447.575,604.534,448.394Z" transform="translate(-462.586 -387.977)" fill="url(#linear-gradient)" />
                </g>
              </svg>

            </div>
            <div>
              <div class="superiority-subtitle">完善便捷的平台功能</div>
              <div class="superiority-desc">除了电脑端的功能以外，本平台还为学员提供了手机端的功能。学员拿着手机就可以随时随地进行学习和练习，提升了学习的便捷程度和学习效果。</div>
            </div>
          </div>
          <div class="superiority-item">
            <div class="superiority-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56" height="56" viewBox="0 0 56 56">
                <defs>
                  <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="#16cfd0" />
                    <stop offset="1" stop-color="#04a7fc" />
                  </linearGradient>
                </defs>
                <path id="路径_53" data-name="路径 53" d="M44.8,52.266A1.868,1.868,0,0,1,44.8,56H11.2a1.868,1.868,0,0,1,0-3.734H44.8ZM46.666,0C51.817,0,56,3.905,56,8.708V39.823c-.007,4.8-4.191,8.708-9.334,8.708H9.333C4.192,48.531,0,44.627,0,39.823V8.709C0,3.905,4.191,0,9.334,0H46.667Zm0,3.734H9.333c-3.09,0-5.6,2.231-5.6,4.975V39.823c0,2.743,2.51,4.975,5.6,4.975H46.664c3.091,0,5.6-2.232,5.6-4.975V8.709c0-2.743-2.509-4.976-5.6-4.976ZM30.891,32.667a1.869,1.869,0,0,1,0,3.733H13.907a1.869,1.869,0,0,1,0-3.733H30.893ZM25.377,13.655l.181.118.2.156A4.852,4.852,0,0,1,26.9,15.313l.122.233.147.32a8.539,8.539,0,0,1,.529,1.689l.064.353.083.524a15.826,15.826,0,0,1,.143,1.587l.013.532L27.994,21a14.224,14.224,0,0,1-.159,1.773l-.075.439-.073.351a8.621,8.621,0,0,1-.568,1.678l-.153.316-.124.231A4.952,4.952,0,0,1,25.7,27.15l-.2.155-.2.133A3.527,3.527,0,0,1,23.57,28l-.23,0-.229,0a3.6,3.6,0,0,1-1.734-.545l-.2-.131-.2-.152a4.861,4.861,0,0,1-1.141-1.351l-.124-.229-.155-.312a8.626,8.626,0,0,1-.579-1.655l-.075-.345-.077-.441a14.168,14.168,0,0,1-.162-1.783l-.006-.448a15.778,15.778,0,0,1,.143-2.132l.081-.528.065-.353a8.97,8.97,0,0,1,.531-1.7l.145-.322.121-.239a4.791,4.791,0,0,1,1.141-1.406l.2-.159.18-.117a3.873,3.873,0,0,1,4.1,0Zm12.137,0,.181.118.2.157a4.928,4.928,0,0,1,1.141,1.384l.123.233.144.321a8.67,8.67,0,0,1,.516,1.689l.062.352.086.524a15.816,15.816,0,0,1,.152,1.587l.016.532L40.128,21a14.216,14.216,0,0,1-.163,1.773l-.075.439-.073.351a8.618,8.618,0,0,1-.569,1.678l-.153.316-.124.231a4.952,4.952,0,0,1-1.141,1.363l-.2.155-.2.133A3.53,3.53,0,0,1,35.7,28l-.23,0-.229,0a3.607,3.607,0,0,1-1.735-.545l-.2-.131-.2-.152a4.862,4.862,0,0,1-1.141-1.351l-.124-.229-.153-.313a8.629,8.629,0,0,1-.572-1.654l-.075-.345-.075-.441a14.16,14.16,0,0,1-.163-1.783l-.006-.448a15.629,15.629,0,0,1,.144-2.132l.08-.528.066-.353a8.955,8.955,0,0,1,.53-1.7l.146-.322.121-.238a4.887,4.887,0,0,1,1.141-1.406l.2-.159.18-.118a3.877,3.877,0,0,1,4.107,0Zm-21.657.891.007.116V26.373A1.625,1.625,0,0,1,14.46,28a1.443,1.443,0,0,1-1.38-1.443V16.059a1.631,1.631,0,0,1-.6-.177l-.113-.077a1.516,1.516,0,0,1-.523-1.111v-.149a1.6,1.6,0,0,1,.424-1.171l.1-.093a2.3,2.3,0,0,1,1.16-.2h.785a1.481,1.481,0,0,1,1.545,1.47Zm19.631,1.323h-.11a.95.95,0,0,0-.495.181l-.108.089-.129.14a2.828,2.828,0,0,0-.417.659l-.077.187-.112.308a6.754,6.754,0,0,0-.245.959l-.051.33-.063.475c-.035.317-.059.637-.071.958l-.009.481.009.474q.017.476.065.946l.059.47.049.308a5.994,5.994,0,0,0,.237.9l.109.287.075.172a2.534,2.534,0,0,0,.4.6l.125.126.1.074a1.044,1.044,0,0,0,.522.185h.138V25.2a.962.962,0,0,0,.6-.181l.1-.084.127-.132a2.756,2.756,0,0,0,.413-.625L36.811,24l.107-.292a6.412,6.412,0,0,0,.237-.913l.049-.314.056-.464q.049-.463.065-.931l.007-.469-.008-.471q-.017-.47-.069-.937l-.061-.467-.048-.332a7.166,7.166,0,0,0-.234-.974l-.108-.314-.077-.187a2.938,2.938,0,0,0-.417-.663l-.128-.141-.088-.074a.937.937,0,0,0-.479-.189l-.128,0Zm-12.152,0h-.109a.945.945,0,0,0-.487.181l-.107.089-.128.14a2.854,2.854,0,0,0-.417.659l-.077.187-.112.308a6.877,6.877,0,0,0-.243.959l-.051.33-.06.475c-.034.317-.056.637-.068.958l-.009.48.007.476c.01.315.033.631.065.945l.06.469.047.308a6.1,6.1,0,0,0,.233.9l.106.287.076.172a2.509,2.509,0,0,0,.405.6l.124.125.1.075a1.036,1.036,0,0,0,.513.185h.137V25.2a.958.958,0,0,0,.63-.189l.091-.075.125-.133a2.637,2.637,0,0,0,.408-.625L24.667,24l.109-.291a6.273,6.273,0,0,0,.238-.913l.049-.315.059-.463c.033-.31.056-.621.068-.931l.01-.469-.009-.47q-.018-.47-.069-.938l-.059-.465-.053-.334a7.175,7.175,0,0,0-.249-.974l-.112-.313-.078-.187a2.831,2.831,0,0,0-.416-.663l-.129-.14-.087-.075a.894.894,0,0,0-.6-.19Z" fill="url(#linear-gradient)" />
              </svg>
            </div>
            <div>
              <div class="superiority-subtitle">行业领先的通过率</div>
              <div class="superiority-desc">依据历次测试的大数据对比分析发现。经过我们的专业培训以及辅导，我们学员的测试通过率显著高于其他非官方培训机构。</div>
            </div>
          </div>
          <div class="superiority-item">
            <div class="superiority-icon">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="57" height="61.079" viewBox="0 0 57 61.079">
                <defs>
                  <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="#16cfd0" />
                    <stop offset="1" stop-color="#04a7fc" />
                  </linearGradient>
                </defs>
                <path id="路径_66" data-name="路径 66" d="M110.02,76.63a2.107,2.107,0,0,1,2.7-1.335,2.2,2.2,0,0,1,1.3,2.781,51.964,51.964,0,0,0-2.482,16.463c0,14.6,5.2,26.177,10.606,26.177,1.68,0,3.447-1.163,5.1-3.514a2.083,2.083,0,0,1,2.962-.486,2.223,2.223,0,0,1,.473,3.047c-2.389,3.385-5.32,5.316-8.54,5.316-8.647,0-14.846-13.815-14.846-30.539A56.274,56.274,0,0,1,110.02,76.63Zm11.26,30q2.677-1.216,5.227-2.69,3.1-1.791,6.029-3.863.213-2.637.212-5.539c0-2-.1-3.933-.277-5.794-1.935-1.165-3.9-2.28-5.7-3.322a59.693,59.693,0,0,0-5.419-2.775q-2.464,1.2-5.176,2.77a53.534,53.534,0,0,0-12.124,9.4,53.73,53.73,0,0,0,11.851,9.107,53.012,53.012,0,0,0,5.379,2.7Zm-5.416,2.116c-.7-.366-1.4-.748-2.083-1.147a58.621,58.621,0,0,1-12.467-9.5c-2.783,3.85-3.8,7.356-2.509,9.589.864,1.494,2.836,2.454,5.826,2.683a2.083,2.083,0,0,1,1.935,2.295,2.218,2.218,0,0,1-2.373,1.963c-4.271-.327-7.517-1.9-9.166-4.76-4.323-7.489,4.542-19.765,19.026-28.129.685-.393,1.359-.774,2.022-1.136-8.4-2.731-15.353-2.421-17.277.91-.914,1.581-.687,3.937.811,6.839a2.085,2.085,0,0,1-.931,2.853,2.221,2.221,0,0,1-2.919-.988c-2.105-4.075-2.471-7.886-.742-10.885,3.567-6.173,14.436-6.21,26.262-1.344a45.287,45.287,0,0,1,7.853-2.8c-1.931-4.256-4.435-6.834-6.987-6.834-1.8,0-3.691,1.331-5.436,4a2.085,2.085,0,0,1-2.945.6,2.221,2.221,0,0,1-.576-3.028c2.458-3.765,5.539-5.931,8.955-5.931,7.164,0,12.648,9.482,14.319,22.246a57.308,57.308,0,0,1,6.413,4.592c3.056-3.691,4.413-7.031,3.17-9.184-.807-1.4-2.587-2.33-5.283-2.631a2.083,2.083,0,0,1-1.852-2.362,2.223,2.223,0,0,1,2.443-1.885c3.926.438,6.915,2,8.47,4.7,2.3,3.983.255,9.325-4.343,14.711a4.206,4.206,0,0,1-1.239,1.385,59.515,59.515,0,0,1-7.663,6.8,48.126,48.126,0,0,1-1.557,8.045c5.462.585,9.7-.273,11.027-2.57.814-1.411.722-3.433-.384-5.942a2.083,2.083,0,0,1,1.11-2.788,2.223,2.223,0,0,1,2.855,1.163c1.61,3.645,1.76,7.037.2,9.749-3.593,6.221-16.094,6.2-28.528,1.224a49.465,49.465,0,0,1-10.224,3.089q-1.021-4.142-.667-4.2a40.7,40.7,0,0,0,5.458-1.39Zm10.885-.087c1.374.423,2.727.779,4.04,1.062a38.3,38.3,0,0,0,1-4.029q-1.548.991-3.163,1.922Q127.692,108.154,126.749,108.659Zm4.926-25.3q-.42-2.1-1.041-4.147a33.639,33.639,0,0,0-4.127,1.226q1.191.622,2.384,1.311Zm5.251,8.239q.065,1.453.065,2.941c0,.72-.009,1.431-.028,2.129,1.084-.91,2.1-1.824,3.032-2.733q-1.476-1.242-3.069-2.334Zm-14.781,5.122a2.182,2.182,0,1,1,2.12-2.181A2.152,2.152,0,0,1,122.144,96.721Z" transform="translate(-93.922 -64)" fill="url(#linear-gradient)" />
              </svg>
            </div>
            <div>
              <div class="superiority-subtitle">专业资深的技术团队</div>
              <div class="superiority-desc">平台由专业资深的技术团队提供技术服务，能够同时满足数以百万计的学员同时在线学习。平台会定期进行迭代升级。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="comment-container">
        <div class="comment-title">用户评价</div>
        <div class="comment-content">
          <div class="comment-item">
            <div class="comment-item-content">
              培训平台真的很好用，是我们用过的网络服务平台最好的一种，非常感谢！
            </div>
            <div class="comment-item-userinfo">
              <span>天宏控股集团有限公司</span>
              <span>|</span>
              <span>周*芬</span>
            </div>
            <div class="comment-item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="35" viewBox="0 0 40 35" fill="#3080b6">
                <path id="quote-left" class="cls-1" d="M36.25,49.5H30v-5a5,5,0,0,1,5-5h.625A1.871,1.871,0,0,0,37.5,37.625v-3.75A1.871,1.871,0,0,0,35.625,32H35A12.5,12.5,0,0,0,22.5,44.5V63.25A3.751,3.751,0,0,0,26.25,67h10A3.751,3.751,0,0,0,40,63.25v-10A3.751,3.751,0,0,0,36.25,49.5Zm-22.5,0H7.5v-5a5,5,0,0,1,5-5h.625A1.87,1.87,0,0,0,15,37.625v-3.75A1.871,1.871,0,0,0,13.125,32H12.5A12.5,12.5,0,0,0,0,44.5V63.25A3.751,3.751,0,0,0,3.75,67h10a3.751,3.751,0,0,0,3.75-3.75v-10A3.751,3.751,0,0,0,13.75,49.5Z" transform="translate(0 -32)" />
              </svg>
            </div>
          </div>
          <div class="comment-item">
            <div class="comment-item-content">
              再也不用每次跑腿了，远程操作一次搞定，感谢培训平台的支持帮助，真心为我们企业排忧解难。
            </div>
            <div class="comment-item-userinfo">
              <span>南昌市第二建筑工程有限公司</span>
              <span>|</span>
              <span>程*青</span>
            </div>
            <div class="comment-item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="35" viewBox="0 0 40 35" fill="#3080b6">
                <path id="quote-left" class="cls-1" d="M36.25,49.5H30v-5a5,5,0,0,1,5-5h.625A1.871,1.871,0,0,0,37.5,37.625v-3.75A1.871,1.871,0,0,0,35.625,32H35A12.5,12.5,0,0,0,22.5,44.5V63.25A3.751,3.751,0,0,0,26.25,67h10A3.751,3.751,0,0,0,40,63.25v-10A3.751,3.751,0,0,0,36.25,49.5Zm-22.5,0H7.5v-5a5,5,0,0,1,5-5h.625A1.87,1.87,0,0,0,15,37.625v-3.75A1.871,1.871,0,0,0,13.125,32H12.5A12.5,12.5,0,0,0,0,44.5V63.25A3.751,3.751,0,0,0,3.75,67h10a3.751,3.751,0,0,0,3.75-3.75v-10A3.751,3.751,0,0,0,13.75,49.5Z" transform="translate(0 -32)" />
              </svg>
            </div>
          </div>
          <div class="comment-item">
            <div class="comment-item-content">
              有了操作指南和流程，网上办事变得简单、方便、快捷多了，还不容易错，发生过的历史资料也可以及时查到，真的很用心也很贴心。
            </div>
            <div class="comment-item-userinfo">
              <span>江西省新宇建设工程有限公司</span>
              <span>|</span>
              <span>李*华</span>
            </div>
            <div class="comment-item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="35" viewBox="0 0 40 35" fill="#3080b6">
                <path id="quote-left" class="cls-1" d="M36.25,49.5H30v-5a5,5,0,0,1,5-5h.625A1.871,1.871,0,0,0,37.5,37.625v-3.75A1.871,1.871,0,0,0,35.625,32H35A12.5,12.5,0,0,0,22.5,44.5V63.25A3.751,3.751,0,0,0,26.25,67h10A3.751,3.751,0,0,0,40,63.25v-10A3.751,3.751,0,0,0,36.25,49.5Zm-22.5,0H7.5v-5a5,5,0,0,1,5-5h.625A1.87,1.87,0,0,0,15,37.625v-3.75A1.871,1.871,0,0,0,13.125,32H12.5A12.5,12.5,0,0,0,0,44.5V63.25A3.751,3.751,0,0,0,3.75,67h10a3.751,3.751,0,0,0,3.75-3.75v-10A3.751,3.751,0,0,0,13.75,49.5Z" transform="translate(0 -32)" />
              </svg>
            </div>
          </div>
          <div class="comment-item">
            <div class="comment-item-content">
              网络培训平台非常完善和实用，咨询电话的老师们也非常热情，解答也很周到，十分满意！希望继续保持。
            </div>
            <div class="comment-item-userinfo">
              <span>江西翰飞建设有限公司</span>
              <span>|</span>
              <span>*美</span>
            </div>
            <div class="comment-item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="35" viewBox="0 0 40 35" fill="#3080b6">
                <path id="quote-left" class="cls-1" d="M36.25,49.5H30v-5a5,5,0,0,1,5-5h.625A1.871,1.871,0,0,0,37.5,37.625v-3.75A1.871,1.871,0,0,0,35.625,32H35A12.5,12.5,0,0,0,22.5,44.5V63.25A3.751,3.751,0,0,0,26.25,67h10A3.751,3.751,0,0,0,40,63.25v-10A3.751,3.751,0,0,0,36.25,49.5Zm-22.5,0H7.5v-5a5,5,0,0,1,5-5h.625A1.87,1.87,0,0,0,15,37.625v-3.75A1.871,1.871,0,0,0,13.125,32H12.5A12.5,12.5,0,0,0,0,44.5V63.25A3.751,3.751,0,0,0,3.75,67h10a3.751,3.751,0,0,0,3.75-3.75v-10A3.751,3.751,0,0,0,13.75,49.5Z" transform="translate(0 -32)" />
              </svg>
            </div>
          </div>
          <div class="comment-item">
            <div class="comment-item-content">
              自从有了南昌市建筑云网络培训平台，业务好办了，工作负担减轻了，效率也提高了，必须点个赞！
            </div>
            <div class="comment-item-userinfo">
              <span>江西省朝晖城市建设工程有限公司</span>
              <span>|</span>
              <span>张*峰</span>
            </div>
            <div class="comment-item-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="35" viewBox="0 0 40 35" fill="#3080b6">
                <path id="quote-left" class="cls-1" d="M36.25,49.5H30v-5a5,5,0,0,1,5-5h.625A1.871,1.871,0,0,0,37.5,37.625v-3.75A1.871,1.871,0,0,0,35.625,32H35A12.5,12.5,0,0,0,22.5,44.5V63.25A3.751,3.751,0,0,0,26.25,67h10A3.751,3.751,0,0,0,40,63.25v-10A3.751,3.751,0,0,0,36.25,49.5Zm-22.5,0H7.5v-5a5,5,0,0,1,5-5h.625A1.87,1.87,0,0,0,15,37.625v-3.75A1.871,1.871,0,0,0,13.125,32H12.5A12.5,12.5,0,0,0,0,44.5V63.25A3.751,3.751,0,0,0,3.75,67h10a3.751,3.751,0,0,0,3.75-3.75v-10A3.751,3.751,0,0,0,13.75,49.5Z" transform="translate(0 -32)" />
              </svg>
            </div>
          </div>
        </div>
        <!-- <div class="comment-page">
          <div class="comment-page-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="9.04" height="14" viewBox="0 0 9.04 14" fill="#F7F7F7">
              <path id="angle-left" class="cls-1" d="M24.97,102.206l5.948-5.948a1.045,1.045,0,0,1,1.483,0l.988.988a1.045,1.045,0,0,1,0,1.483l-4.212,4.221,4.216,4.216a1.045,1.045,0,0,1,0,1.483l-.988.993a1.045,1.045,0,0,1-1.483,0l-5.948-5.948a1.047,1.047,0,0,1,0-1.487Z" transform="translate(-24.662 -95.95)" />
            </svg>
          </div>
          <div class="comment-page-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="9.035" height="14" viewBox="0 0 9.035 14" fill="#F7F7F7">
              <path id="angle-right" class="cls-1" d="M33.478,103.694l-5.948,5.948a1.045,1.045,0,0,1-1.483,0l-.988-.988a1.045,1.045,0,0,1,0-1.483l4.216-4.216-4.216-4.216a1.045,1.045,0,0,1,0-1.483l.984-1a1.045,1.045,0,0,1,1.483,0l5.948,5.948A1.047,1.047,0,0,1,33.478,103.694Z" transform="translate(-24.75 -95.95)" />
            </svg>
          </div>
        </div> -->
      </div>
    </section>
    <section v-show="projectName != 'ZJJYJZY'" id="ques-section" class="ques-section">
      <div class="container">
        <div class="section-title mb45 headline text-center ">
          <h2>使用帮助及常见问题解答</h2>
        </div>
        <div class="ques-tab">
          <!-- <div :class="quesTabIndex == 0 ? 'ques-tab-item active' : 'ques-tab-item'" @click="changeQuesTab(0)">平台使用</div>
          <div :class="quesTabIndex == 1 ? 'ques-tab-item active' : 'ques-tab-item'" @click="changeQuesTab(1)">八大员</div>
          <div :class="quesTabIndex == 2 ? 'ques-tab-item active' : 'ques-tab-item'" @click="changeQuesTab(2)">三类人员</div>
          <div :class="quesTabIndex == 3 ? 'ques-tab-item active' : 'ques-tab-item'" @click="changeQuesTab(3)">特种作业</div>
          <div :class="quesTabIndex == 4 ? 'ques-tab-item active' : 'ques-tab-item'" @click="changeQuesTab(4)">技术工人</div> -->
        </div>
        <div class="ques-tab-content">
          <div v-show="quesTabIndex == 0">
            <div class="row">
              <div class="col-md-6">
                <div class="ques-ans mb45 headline">
                  <h3>关于平台</h3>
                  <p>平台是由南昌市建筑教育培训中心、南昌市建筑工程技工学校和杭州科锐极科技有限公司合作开发。平台由南昌市建筑教育培训中心、南昌市建筑工程技工学校主办，杭州科锐极科技有限公司提供技术支持。</p>
                </div>

                <div class="ques-ans mb45 headline">
                  <h3>关于学员使用</h3>
                  <p>平台包含了专为学员使用的在线学习系统，由企业报名的课程审核通过后学员可使用身份证号进行登录。登录成功后会自动跳转至在线学习系统。在线学习系统操作手册<a v-show="projectName == 'NCJZJY'" href="https://ncjzjy-1253588055.cos.ap-shanghai.myqcloud.com/notice/%E5%8D%97%E6%98%8C%E5%B8%82%E5%BB%BA%E7%AD%91%E5%9F%B9%E8%AE%AD%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E-%E5%AD%A6%E5%91%98.pdf" style="color: #17d0cf;" target="_blank">点击此处下载</a><a v-show="projectName == 'SRJZY'" href="https://srsjzy-1253588055.cos.ap-shanghai.myqcloud.com/assets/notice/%E5%BB%BA%E7%AD%91%E4%BA%91%E5%9F%B9%E8%AE%AD%E5%B9%B3%E5%8F%B0%E7%94%A8%E6%88%B7%E6%89%8B%E5%86%8C%EF%BC%88%E5%AD%A6%E5%91%98%E7%AF%87%EF%BC%89V0.1.pdf" style="color: #17d0cf;" target="_blank">点击此处下载</a>。</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="ques-ans mb45 headline">
                  <h3>关于浏览器</h3>
                  <p>平台基于 Chromium 内核的浏览器开发，推荐使用没有广告、干净、纯净的 Microsoft Edge 浏览器、Google Chrome 浏览器或者 QQ 浏览器、搜狗浏览器、360 极速浏览器。</p>
                </div>

                <div class="ques-ans mb45 headline">
                  <h3>关于企业使用</h3>
                  <p>平台包含了专为企业使用的企业管理系统，企业通过企业注册功能完成注册并且审核通过后可使用注册时填写的企业名称进行登录。登录成功后会自动跳转至企业管理系统。企业管理系统操作手册<a v-show="projectName == 'NCJZJY'" href="https://ncjzjy-1253588055.cos.ap-shanghai.myqcloud.com/notice/%E5%8D%97%E6%98%8C%E5%B8%82%E5%BB%BA%E7%AD%91%E5%9F%B9%E8%AE%AD%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E-%E4%BC%81%E4%B8%9A.pdf" style="color: #17d0cf;" target="_blank">点击此处下载</a><a v-show="projectName == 'SRJZY'" href="https://srsjzy-1253588055.cos.ap-shanghai.myqcloud.com/assets/notice/%E5%BB%BA%E7%AD%91%E4%BA%91%E5%9F%B9%E8%AE%AD%E5%B9%B3%E5%8F%B0%E7%94%A8%E6%88%B7%E6%89%8B%E5%86%8C%EF%BC%88%E4%BC%81%E4%B8%9A%E7%AF%87%EF%BC%89%20V0.1.pdf" style="color: #17d0cf;" target="_blank">点击此处下载</a>。</p>
                </div>
              </div>
            </div>
          </div>
          <div v-show="quesTabIndex == 1"></div>
          <div v-show="quesTabIndex == 2"></div>
          <div v-show="quesTabIndex == 3"></div>
          <div v-show="quesTabIndex == 4"></div>
        </div>
      </div>
    </section>
    <section v-show="projectName == 'NCJZJY'" class="teachers-section">
      <div class="teachers-container">
        <div class="teachers-title">师资力量</div>
        <div class="teachers-content">
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/尹丽红.jpg">
              </div>
            </div>
            <div class="teacher-item-name">尹丽红</div>
            <!-- <div class="teacher-item-job">讲师</div> -->
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/沈峰.jpg">
              </div>
            </div>
            <div class="teacher-item-name">沈峰</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/陈文辉.jpg">
              </div>
            </div>
            <div class="teacher-item-name">陈文辉</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/王玉芳.jpg">
              </div>
            </div>
            <div class="teacher-item-name">王玉芳</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/付晓峰.jpg">
              </div>
            </div>
            <div class="teacher-item-name">付晓峰</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/古柳.jpg">
              </div>
            </div>
            <div class="teacher-item-name">古柳</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/李剑.jpg">
              </div>
            </div>
            <div class="teacher-item-name">李剑</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/潘芬.jpg">
              </div>
            </div>
            <div class="teacher-item-name">潘芬</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/汤鹏辉.jpg">
              </div>
            </div>
            <div class="teacher-item-name">汤鹏辉</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/吴智华.jpg">
              </div>
            </div>
            <div class="teacher-item-name">吴智华</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/夏静.jpg">
              </div>
            </div>
            <div class="teacher-item-name">夏静</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/徐小红.jpg">
              </div>
            </div>
            <div class="teacher-item-name">徐小红</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/喻涛.jpg">
              </div>
            </div>
            <div class="teacher-item-name">喻涛</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/周晓勇.jpg">
              </div>
            </div>
            <div class="teacher-item-name">周晓勇</div>
          </div>
          <div class="teachers-item">
            <div class="teachers-item-image-border">
              <div class="teachers-item-image">
                <img src="../../assets/img/teacher/朱存金.jpg">
              </div>
            </div>
            <div class="teacher-item-name">朱存金</div>
          </div>
        </div>
      </div>
    </section>
    <section v-show="projectName != 'ZJJYJZY'" id="contact-section" class="contact-section">
      <div class="contact-container">
        <div class="contact-info">
          <div class="contact-title">联系我们</div>
          <div class="contact-row">
            <div class="contact-item">
              <div class="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32" fill="#FFFFFF">
                  <path id="map-marker-alt" class="cls-1" d="M10.767,31.354C1.686,18.189,0,16.838,0,12a12,12,0,0,1,24,0c0,4.838-1.686,6.189-10.767,19.354a1.5,1.5,0,0,1-2.466,0ZM12,17a5,5,0,1,0-5-5A5,5,0,0,0,12,17Z" />
                </svg>
              </div>
              <div v-if="projectName == 'NCJZJY'" class="contact-text">
                地址：江西省南昌市红谷滩区复兴大道西3499号<br>
                邮编：330001
              </div>
              <div v-else-if="projectName == 'SRJZY'" class="contact-text">
                地址：江西省上饶市高铁经济试验区茶圣东路文创南区2号楼4楼<br>
                电话：8201030
              </div>
            </div>
          </div>
          <div class="contact-row">
            <div class="contact-item">
              <div class="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="#FFFFFF">
                  <path id="phone" class="cls-1" d="M30.827,1.527l-6.5-1.5A1.51,1.51,0,0,0,22.608.9l-3,7a1.5,1.5,0,0,0,.431,1.75l3.787,3.1A23.163,23.163,0,0,1,12.752,23.82l-3.1-3.787A1.5,1.5,0,0,0,7.9,19.6l-7,3a1.518,1.518,0,0,0-.875,1.725l1.5,6.5A1.5,1.5,0,0,0,2.99,31.989a29,29,0,0,0,29-29A1.5,1.5,0,0,0,30.827,1.527Z" transform="translate(0.01 0.011)" />
                </svg>
              </div>
              <div v-if="projectName == 'NCJZJY'" class="contact-text">
                三类业务咨询：15279177006 张老师<br>
                特种业务咨询：15279177006 张老师<br>
                技术工人业务咨询：15279177006 张老师<br>
                十大员业务咨询：17379117878 魏老师
              </div>
              <div v-else-if="projectName == 'SRJZY'" class="contact-text">
                培训咨询：18679333713 罗杰<br>
                财务咨询：13767304405 王红仙<br>
                投诉监督：13970336977 王小芳<br>
                QQ&nbsp;群&nbsp;号：461089795
              </div>
            </div>
          </div>
          <div class="contact-row">
            <div class="contact-item">
              <div class="contact-icon">
                <svg t="1652950190810" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8403" height="52" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <path d="M469.333333 682.666667v-85.333334H256v-85.333333h213.333333v-34.133333L264.533333 273.066667 328.533333 213.333333 512 396.8 695.466667 213.333333l59.733333 59.733334-200.533333 204.8v34.133333h213.333333v85.333333h-213.333333v85.333334h213.333333v85.333333h-213.333333v85.333333h-85.333334v-85.333333H256v-85.333333h213.333333z" fill="#ffffff" p-id="8404"></path>
                </svg>
              </div>
              <div v-if="projectName == 'NCJZJY'" class="contact-text">
                收款户名：南昌技师学院<br>
                收款账号：1502207029081005612-000000002<br>
                收款银行：中国工商银行股份有限公司南昌胜利支行<br>
                缴费群号：522613867
              </div>
              <div v-else-if="projectName == 'SRJZY'" class="contact-text">
                三类、特种、八大员统一缴费账户<br>
                收款户名：上饶市国控职业培训学校有限公司<br>
                收款账号：159389010000033356<br>
                收款银行：上饶农村商业银行股份有限公司三清支行
              </div>
            </div>
          </div>
        </div>
        <div class="contact-map" :style="'background-image: url('+mapImgUrl+');'">

        </div>
      </div>
    </section>
    <section v-show="projectName != 'ZJJYJZY'" id="about-section" class="about-section">
      <div class="about-container">
        <div v-if="projectName == 'NCJZJY'" class="about-info">
          <div class="about-logo">
            <div><img src="../../assets/img/logo.png"></div>
            <div>
              <div class="about-logo-title">南昌市建筑工程技工学校</div>
              <div class="about-logo-authority">南昌市建筑教育培训中心</div>
            </div>
          </div>
          <div class="about-desc">
            南昌市建筑工程中专学校，南昌市建筑工程技工学校，南昌市建筑教育培训中心为“三牌一体”建制，是经政府部门批准成立的全日制公办学校，隶属于南昌市城乡建设委员会。同时被劳动部门授予职业技能鉴定站；建设部门、人事部门授予建设类培训基地，是全省建设行业职业培训机构之一。学校融本科、大专、中专及技校等学历教育、职业技能培训、专业岗位培训为一体，是南昌市建设系统唯一一所行业性的培养高、中级应用型人才的职业技术学校。
          </div>
        </div>
        <div v-else-if="projectName == 'SRJZY'" class="about-info">
          <div class="about-logo">
            <div><img style="width: auto;" src="https://srsjzy-1253588055.cos.ap-shanghai.myqcloud.com/assets/logo2_20230216.png"></div>
          </div>
          <div class="about-desc">
            上饶市国控职业培训学校有限公司为原上饶市建设培训中心，由上饶市国控投资集团有限公司控股，于2021年10月正式成立。开展特种工、三类人员、职业技能、现场领域施工人员、二级建造师继续教育等培训工作。
          </div>
        </div>
        <div class="about-link">
          <div class="about-title">上级部门</div>
          <div class="about-link-item">
            <div class="about-link-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="#16cfd0">
                <path id="caret-right" class="cls-1" d="M0,118.49V108.107c0-.719,1.022-1.079,1.619-.571l6.1,5.191a.725.725,0,0,1,0,1.141l-6.1,5.191C1.022,119.569,0,119.208,0,118.49Z" transform="translate(0 -107.298)" />
              </svg>
            </div>
            <div class="about-link-text"><a href="http://www.mohurd.gov.cn" target="_blank" rel="noopener noreferrer">中华人民共和国住房和城乡建设部</a></div>
          </div>
          <div class="about-link-item">
            <div class="about-link-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="#16cfd0">
                <path id="caret-right" class="cls-1" d="M0,118.49V108.107c0-.719,1.022-1.079,1.619-.571l6.1,5.191a.725.725,0,0,1,0,1.141l-6.1,5.191C1.022,119.569,0,119.208,0,118.49Z" transform="translate(0 -107.298)" />
              </svg>
            </div>
            <div class="about-link-text"><a href="http://zjt.jiangxi.gov.cn/" target="_blank" rel="noopener noreferrer">江西省住房和城乡建设厅</a></div>
          </div>
          <div v-show="projectName == 'NCJZJY'" class="about-link-item">
            <div class="about-link-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="#16cfd0">
                <path id="caret-right" class="cls-1" d="M0,118.49V108.107c0-.719,1.022-1.079,1.619-.571l6.1,5.191a.725.725,0,0,1,0,1.141l-6.1,5.191C1.022,119.569,0,119.208,0,118.49Z" transform="translate(0 -107.298)" />
              </svg>
            </div>
            <div class="about-link-text"><a href="http://jw.nc.gov.cn/" target="_blank" rel="noopener noreferrer">南昌市城乡建设局</a></div>
          </div>
          <div v-show="projectName == 'SRJZY'" class="about-link-item">
            <div class="about-link-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="#16cfd0">
                <path id="caret-right" class="cls-1" d="M0,118.49V108.107c0-.719,1.022-1.079,1.619-.571l6.1,5.191a.725.725,0,0,1,0,1.141l-6.1,5.191C1.022,119.569,0,119.208,0,118.49Z" transform="translate(0 -107.298)" />
              </svg>
            </div>
            <div class="about-link-text"><a href="http://zjj.zgsr.gov.cn/" target="_blank" rel="noopener noreferrer">上饶市住房和城乡建设局</a></div>
          </div>
          <div class="about-title" style="margin-top: 48px;">关联平台</div>
          <div class="about-link-item">
            <div class="about-link-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="#16cfd0">
                <path id="caret-right" class="cls-1" d="M0,118.49V108.107c0-.719,1.022-1.079,1.619-.571l6.1,5.191a.725.725,0,0,1,0,1.141l-6.1,5.191C1.022,119.569,0,119.208,0,118.49Z" transform="translate(0 -107.298)" />
              </svg>
            </div>
            <div class="about-link-text"><a href="http://www.urdt.cn" target="_blank" rel="noopener noreferrer">江西省住房和城乡建设培训网</a></div>
          </div>
          <div class="about-link-item">
            <div class="about-link-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="#16cfd0">
                <path id="caret-right" class="cls-1" d="M0,118.49V108.107c0-.719,1.022-1.079,1.619-.571l6.1,5.191a.725.725,0,0,1,0,1.141l-6.1,5.191C1.022,119.569,0,119.208,0,118.49Z" transform="translate(0 -107.298)" />
              </svg>
            </div>
            <div class="about-link-text"><a href="http://zjy.jxjst.gov.cn/" target="_blank" rel="noopener noreferrer">江西住建云</a></div>
          </div>
          <div class="about-link-item">
            <div class="about-link-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="#16cfd0">
                <path id="caret-right" class="cls-1" d="M0,118.49V108.107c0-.719,1.022-1.079,1.619-.571l6.1,5.191a.725.725,0,0,1,0,1.141l-6.1,5.191C1.022,119.569,0,119.208,0,118.49Z" transform="translate(0 -107.298)" />
              </svg>
            </div>
            <div class="about-link-text"><a href="http://admin.zhujianpeixun.com/" target="_blank" rel="noopener noreferrer">住房城乡建设行业从业人员培训管理信息系统</a></div>
          </div>
        </div>
        <div class="about-weixin">
          <div class="about-title">微信公众号</div>
          <div>
            <img :src="qrCodeURL" alt="">
          </div>
        </div>
      </div>
    </section>
    <!-- 忘记密码 -->
    <div class="modal fade" id="forgetPassword" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin: 5.75rem auto;">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header backgroud-style">
            <div class="gradient-bg"></div>
            <div class="popup-logo">
              <!-- <img src="assets/img/logo/p-logo.jpg" alt=""> -->
            </div>
            <div class="popup-text text-center">
              <h2> <span>忘记</span> 密码</h2>
            </div>
          </div>

          <div class="modal-body">
            <el-form :model="forgetModel" :rules="forgetRules" ref="forgetForm" :validate-on-rule-change="true" label-width="0px" class="contact_form">
              <el-form-item class="contact-info" prop="Username">
                <el-input class="name" v-model.trim="forgetModel.Username" placeholder="账号(身份证号/企业名称)"></el-input>
              </el-form-item>

              <el-form-item prop="VerifyCode" class="contact-info" style="width:270px;">
                <div style="display:flex;">
                  <el-input style="width: 270px;" class="name" v-model.trim="forgetModel.VerifyCode" placeholder="验证码"></el-input>
                  <div class="yanzhenma" id="TencentCaptchaWJMM" @click="postSendChangePwdVerifycode(forgetModel)">
                    <a :class="timerNub==0?'link' : 'disabled' " style="color: #16cfd0;">
                      <span v-if="timerNub!=0">( {{timerNub}} )</span>
                      <span v-else-if="timerNub==0">获取验证码</span>
                    </a>
                  </div>
                </div>
              </el-form-item>

              <el-form-item class="contact-info" prop="Password">
                <el-input v-model.trim="forgetModel.Password" class="name" :type="inputType" autocomplete="new-password" @focus="changePasswordinput" placeholder="新的密码"></el-input>
              </el-form-item>

              <el-form-item class="contact-info" prop="NewPassword">
                <el-input v-model.trim="forgetModel.NewPassword" class="name" :type="inputType" autocomplete="new-password" @focus="changePasswordinput" placeholder="确认密码"></el-input>
              </el-form-item>

              <div class="nws-button text-center white " style="display:flex; justify-content: space-between;line-height: 32px;">
                <!-- <span style="color:ff6715;">{{rules.ErrorMessages}}</span> -->
              </div>
            </el-form>
            <div class="nws-button text-center white text-capitalize" style="    margin-top: 4px;">
              <button type="submit" @click="changePassword()">修改密码</button>
            </div>

            <div class="log-in-footer text-center" style="margin-top:20px;">
              <p>* 企业用户请使用企业名称登录</p>
              <p>* 个人用户请使用身份证号登录</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <k-weixin></k-weixin> -->
  </div>

  <div v-else>
    <section id="course-page" style="background-color: #FFF;" class="course-page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <div class="genius-post-item">
              <div class="tab-container">
                <div id="tab1" class="pt35">
                  <div class="best-course-area best-course-v2">
                    <div class="row">
                      <div v-for="item in courses" :key="item.Id" class="col-md-4" :style="item.IsOpen==1?'':'opacity: 1;'" @click="goCourseDetails(item.Id)">
                        <div class="best-course-pic-text relative-position" style="cursor: pointer;">
                          <div class="best-course-pic relative-position">
                            <img :src="item.Pic" alt="">
                            <div class="course-details-btn">
                              <a>进入报名 <i class="fas fa-arrow-right"></i></a>
                            </div>
                            <div class="blakish-overlay"></div>
                            <label v-if="item.IsHot==1" class="item-status-label shz">
                              <i class="iconfont icon-shandian-shi" style="margin-bottom: -4px;"></i>
                              <span>火热报名中</span>
                            </label>
                          </div>
                          <div class="best-course-text">
                            <div class="course-title mb20 headline relative-position">
                              <h3 style="-webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    display: -webkit-box;"><a>{{item.Name}}</a></h3>
                            </div>
                            <div class="course-meta" v-if="item.ManualUrl && item.IsOpen == 1">
                              <span class="course-category"><a>报名开放</a></span>
                              <span class="course-author" @click="stopPropagation($event)"><a style="color:#17d0cf !important" target="_blank" :href="item.ManualUrl">查看报名流程</a></span>
                            </div>
                            <div class="course-meta" v-else>
                              <span class="course-category"><a>{{item.JobCount}}个岗位</a></span>
                              <span class="course-author"><a>{{item.IsOpen==1?"报名开放":"暂未开放"}}</a></span>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div><!-- /tab-1 -->
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <component :is="newsView" ref="newsView" :is2WM="false"></component>
          </div>
        </div>
      </div>
    </section>
    <k-weixin></k-weixin>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { Vue, mapGetters, ProjectSettings } from '../base/base.js';

export default {
  data() {
    let that = this;
    let validatePass = (rule, value, callback) => {
      if (that.rulesErrorMessages !== '') {
        callback(new Error(that.rulesErrorMessages));
      } else {
        callback();
      }
    };
    let validatePass1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码必须为 6 位以上字母或数字'));
      } else {
        if (this.forgetModel.NewPassword !== '') {
          this.$refs.forgetForm.validateField('NewPassword');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.forgetModel.Password) {
        callback(new Error('密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      model: {
        UserTypeId: '3',
        UserName3: null,
        Password3: null,
        UserName2: null,
        Password2: null,
        UserName1: null,
        Password1: null
      },
      forgetModel: {
        Username: null,
        Password: null,
        VerifyCode: null,
        NewPassword: null
      },
      rules3: {
        UserName3: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        Password3: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      rules2: {
        UserName2: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        Password2: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      rules1: {
        UserName1: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        Password1: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      rulesErrorMessages: '',
      forgetRules: {
        Username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        VerifyCode: [
          { required: true, message: '请填写验证码', trigger: ['blur', 'change'] }
        ],
        Password: [
          { required: true, validator: validatePass1, trigger: ['blur', 'change'] }
        ],
        NewPassword: [
          { required: true, validator: validatePass2, trigger: ['blur', 'change'] }
        ],
        ErrorMessages: ''
      },
      userNamePlaceholder: '请输入帐号（默认：身份证号）',
      passwordPlaceholder: '请输入密码',
      loginPasswordType3: 'text',
      loginPasswordType2: 'text',
      loginPasswordType1: 'text',
      projectName: ProjectSettings.Name,
      bannerBgURL: ProjectSettings.BannerBgURL,
      NewHomePage: ProjectSettings.NewHomePage,
      mapImgUrl: ProjectSettings.MapImgUrl,
      displayName: null,
      timerNub: 0,
      queryModel: {
        Page: 1,
        PageSize: 6
      },
      qrCodeURL: ProjectSettings.WeiXinURL,
      quesTabIndex: 0,
      inputType: 'text'
    }
  },
  computed: {
    ...mapGetters({
      courses: 'getCourseRecommends'
    })
  },
  created: function () {
    this.jxszContent = Vue.component('jxszContent', function (resolve) {
      require(['./jxsz/content'], resolve)
    });
    this.newsView = Vue.component('newsView', function (resolve) {
      require(['./new/index_list'], resolve)
    });
    this.testsView = Vue.component('testsView', function (resolve) {
      require(['./test/index_list'], resolve)
    });
    this.bwcxnjsmView = Vue.component('testsView', function (resolve) {
      require(['./bwcxnjsm/index_list'], resolve)
    });
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.displayName = Cookies.get('DisplayName');
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.displayName = Cookies.get('DisplayName');
    next();
  },
  mounted() {
    let that = this;
    this.displayName = Cookies.get('DisplayName');

    this.loginPasswordType3 = 'text';
    this.loginPasswordType2 = 'text';
    this.loginPasswordType1 = 'text';

    if (this.$route.query.toSection) {
      $('html,body').animate({ scrollTop: $('#' + this.$route.query.toSection).offset().top }, 1000);
    }

    $('#forgetPassword').on('hidden.bs.modal', function (e) {
      that.model = {
        UserTypeId: '3',
        UserName3: null,
        Password3: null,
        UserName2: null,
        Password2: null,
        UserName1: null,
        Password1: null
      };
      that.forgetModel = {
        Username: null,
        Password: null,
        VerifyCode: null,
        NewPassword: null
      };
      that.$refs.forgetForm.resetFields();
    });

    this.$store.dispatch('getCourseRecommends', {});
    $('.jarallax').jarallax({
      speed: 0.5
    });

    $('.superiority-row').owlCarousel({
      margin: 116,
      responsiveClass: true,
      nav: false,
      autoplay: true,
      stopOnHover: true,
      smartSpeed: 1000
    });
    $('.comment-content').owlCarousel({
      margin: 84,
      items: 2,
      responsiveClass: true,
      nav: true,
      navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
      autoplay: false,
      dots: false,
      smartSpeed: 1000
    });
    $('.teachers-content').owlCarousel({
      margin: 30,
      items: 4,
      responsiveClass: true,
      nav: true,
      navText: ["<i class='fas fa-chevron-left'></i>", "<i class='fas fa-chevron-right'></i>"],
      autoplay: false,
      dots: false,
      smartSpeed: 1000
    });

    // setTimeout(function () {
    //   $('#contactMap').attr('src', '//uri.amap.com/marker?poiid=B0FFHNY9KH&src=南昌市建筑云培训平台&callnative=0');
    // }, 1000)
  },
  methods: {
    goCourseDetails(id) {
      let routeUrl = this.$router.resolve({
        path: 'courseDetails',
        query: {
          Id: id
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    changeQuesTab(index) {
      this.quesTabIndex = index;
    },
    register() {
      this.$router.push({ name: 'register' });
    },
    handleUserTypeSelect() {
      console.log('usertypeid', this.model.UserTypeId);
      if (this.model.UserTypeId === '3') {
        this.model.UserName3 = null;
        this.model.Password3 = null;
        this.userNamePlaceholder = '请输入帐号（默认：身份证号）';
        this.passwordPlaceholder = '请输入密码';
      } else if (this.model.UserTypeId === '2') {
        this.model.UserName2 = null;
        this.model.Password2 = null;
        this.userNamePlaceholder = '请输入帐号（默认：企业名称）';
        this.passwordPlaceholder = '请输入密码';
      } else if (this.model.UserTypeId === '1') {
        this.model.UserName1 = null;
        this.model.Password1 = null;
        this.userNamePlaceholder = '请输入帐号';
        this.passwordPlaceholder = '请输入密码';
      }
    },
    handleLoginPasswordInput3Focus() {
      this.loginPasswordType3 = 'password';
    },
    handleLoginPasswordInput2Focus() {
      this.loginPasswordType2 = 'password';
    },
    handleLoginPasswordInput1Focus() {
      this.loginPasswordType1 = 'password';
    },
    login() {
      let that = this;
      this.rulesErrorMessages = '';
      let model = {
        UserTypeId: this.model.UserTypeId,
        UserName: null,
        Password: null
      }
      if (this.model.UserTypeId === '3') {
        model.UserName = this.model.UserName3
        model.Password = this.model.Password3
      } else if (this.model.UserTypeId === '2') {
        model.UserName = this.model.UserName2
        model.Password = this.model.Password2
      } else if (this.model.UserTypeId === '1') {
        model.UserName = this.model.UserName1
        model.Password = this.model.Password1
      }
      console.log('loginForm' + this.model.UserTypeId);
      console.log('model', model);
      this.$refs['loginForm' + this.model.UserTypeId].validate((valid) => {
        if (valid) {
          let captcha = new TencentCaptcha('2049138413',
            function (res) {
              if (res.ret === 0) {
                that.loginFormloading = true;
                let obj = {
                  Ticket: res.ticket,
                  Randstr: res.randstr
                }
                obj = _.assign(obj, model);

                that.$store.dispatch('login', obj).then(response => {
                  that.loginFormloading = false;
                  if (response.MsgCode === 0) {
                    let data = response.Data;
                    Cookies.set('Token', data.Token);
                    Cookies.set('UserName', data.UserName);
                    Cookies.set('DisplayName', data.DisplayName);
                    Cookies.set('UserTypeId', data.UserTypeId);
                    Cookies.set('YYMenus', data.YYMenus);

                    if (data.UserTypeId === 1) {
                      $('#loginModal').modal('hide');
                      Cookies.set('moduleName', '运营管理系统');
                      Cookies.set('moduleHref', data.YYMenus[0]);

                      that.$router.push({ name: data.YYMenus[0] });
                    } else if (data.UserTypeId === 2) {
                      Cookies.set('moduleName', '企业管理系统');
                      Cookies.set('moduleHref', 'qyglwdbm');

                      if (that.$route.name === 'courseDetails') {
                        $('#loginModal').modal('hide');
                        that.$router.push({ name: 'courseEnroll', query: { CourseId: this.$route.query.Id } });
                      } else {
                        window.location.href = '/qygl/wdbm';
                        if (that.qrCodeURL) {
                          Cookies.set('isGongGao', 'false');
                        }
                      }
                    } else if (data.UserTypeId === 3) {
                      Cookies.set('moduleName', '在线学习系统');
                      Cookies.set('moduleHref', 'wdxx');
                      // this.$router.push({ name: 'wdxx' });
                      window.location.href = '/zxxxgl/wdxx';
                      if (that.qrCodeURL) {
                        Cookies.set('isGongGao', 'false');
                      }
                    } else {
                      window.location.href = 'index';
                    }

                    that.moduleName = Cookies.get('moduleName');
                    that.moduleHref = Cookies.get('moduleHref');
                  } else if (response.MsgCode === 1) {
                    that.rulesErrorMessages = response.Message;
                    that.$refs['loginForm' + model.UserTypeId].validateField('Password' + model.UserTypeId);
                    // that.$refs['loginForm2'].validateField('Password2');
                    // that.$refs['loginForm1'].validateField('Password1');
                  } else {
                    that.$alert(response.Message, '提示', {
                      confirmButtonText: '确定',
                      callback: action => {
                      }
                    });
                  }
                }).catch(err => {
                  that.loginFormloading = false;
                  console.log(err);
                });
              }
            }
          );
          captcha.show();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    outLogin() {
      Cookies.remove('moduleName');
      Cookies.remove('moduleHref');
      Cookies.remove('Token');
      Cookies.remove('UserTypeId');
      Cookies.remove('UserName');
      Cookies.remove('DisplayName');
      Cookies.remove('YYMenus');

      this.displayName = null;

      this.model = {
        UserTypeId: '3',
        UserName3: null,
        Password3: null,
        UserName2: null,
        Password2: null,
        UserName1: null,
        Password1: null
      };
    },
    toMGT() {
      let moduleHref = Cookies.get('moduleHref');
      this.$router.push({ name: moduleHref });
    },
    showForgetPassword() {
      $('#forgetPassword').modal('show');
    },
    postSendChangePwdVerifycode(model) {
      if (!model.Username) {
        this.$alert('请输入正确的账号！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.timerNub !== 0) {
        return;
      }
      let that = this;
      let maxtime = 60;

      let captcha = new TencentCaptcha('2049138413',
        function (res) {
          if (res.ret === 0) {
            let obj = {
              Ticket: res.ticket,
              Randstr: res.randstr
            }
            obj = _.assign(obj, model);

            that.$store.dispatch('postSendChangePwdVerifycode', obj).then((response) => {
              if (response.MsgCode === 1) {
                window.clearInterval(window.Interval.timer);
                that.timerNub = 0;
              }
              that.$alert(response.Message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  // this.$message({
                  //   type: 'info',
                  //   message: `action: ${ action }`
                  // });
                }
              });
            });
          }
        }
      );
      captcha.show();

      window.Interval.timer = window.setInterval(() => {
        maxtime--;
        that.timerNub = maxtime;
        if (maxtime <= 0) {
          that.timerNub = 0;
          window.clearInterval(window.Interval.timer);
        }
      }, 1000);
    },
    changePassword() {
      let that = this;
      this.$refs['forgetForm'].validate((valid) => {
        if (valid) {
          that.$store.dispatch('putChangePassword', that.forgetModel).then(response => {
            if (response.MsgCode === 0) {
              $('#forgetPassword').modal('hide');
            }
            that.$alert(response.Message, '提示', {
              confirmButtonText: '确定'
            });
          }).catch(err => {
            console.log(err);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    changePasswordinput() {
      this.inputType = 'password';
    },
    stopPropagation(e) {
      e.stopPropagation();
    }
  }
}
</script>

<style lang="scss" scoped>
a:not([href]):not([tabindex]) {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.jfxx-section {
  padding: 16px 0px 16px 0px;
  background-color: #fff;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
}
.course-page-section {
  padding: 48px 0px 16px 0px;
  background-color: #f7f7f7;

  .widget-title {
    font-size: 30px;
    font-weight: 500;
    span {
      font-weight: bold;
    }
  }
  .course-title h3 {
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    display: -webkit-box;
    a {
      color: #333333 !important;
      text-decoration: none;
    }
  }

  .course-category,
  .course-author {
    a {
      color: #777777 !important;
    }
  }

  .item-status-label {
    position: absolute;
    left: -60px;
    top: -60px;
    width: 120px;
    height: 120px;
    background-color: #ff6715;
    text-align: center;
    transform: rotate(-45deg);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    i {
      color: #fff;
    }
    span {
      margin-top: 4px;
      margin-bottom: 8px;
      color: #fff;
      font-size: 12px;
    }
    &.tg {
      background-color: #16cfd0;
    }
    &.jj {
      background-color: #a8a8a8;
    }
    &.shz {
      background-color: #ff6715;
    }
  }
}
.news-section {
  min-height: 428px;
  background-color: #fff;
  padding: 48px 0;
}
.step-section {
  height: 144px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .step-item {
    width: 146px;
    height: 96px;
    border-right: 1px solid #d8d8d8;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &:last-child {
      border-right: 0px;
    }
    .step-item-icon {
      margin-bottom: 16px;
    }
    .step-item-text {
      height: 21px;
      font-size: 16px;
      line-height: 21px;
      color: #2f2f2f;
    }
  }
}
.superiority-section {
  background-image: url('../../assets/img/superiority-bg.png');
  height: 840px;
  padding-top: 96px;
  .superiority-title {
    height: 64px;
    font-size: 48px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    margin-bottom: 48px;
  }
  .superiority-content {
    width: 1170px;
    margin-left: auto;
    margin-right: auto;
    .superiority-row {
      .superiority-item {
        width: 320px;
        height: 160px;
        display: flex;
        .superiority-icon {
          margin-right: 16px;
        }
        .superiority-subtitle {
          height: 25px;
          font-size: 19px;
          font-weight: bold;
          line-height: 21px;
          color: #ffffff;
          margin-bottom: 12px;
        }
        .superiority-desc {
          height: 123px;
          font-size: 16px;
          line-height: 24px;
          color: #83bee9;
        }
      }
    }
  }
  .comment-container {
    width: 1170px;
    margin: 0px auto;
    position: relative;
    .comment-title {
      height: 45px;
      font-size: 34px;
      font-weight: bold;
      color: #fff;
      margin-bottom: 66px;
    }
    .comment-title:after {
      content: '';
      position: absolute;
      top: 64px;
      height: 2px;
      width: 48px;
      left: 0;
      background-color: #17d0cf;
    }
    .comment-content {
      .comment-item {
        width: 542px;
        height: 202px;
        border: 2px solid #3080b6;
        border-radius: 5px;
        margin-bottom: 63px;
        padding: 30px;
        position: relative;
        .comment-item-content {
          height: 97px;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          color: #fff;
          overflow: hidden;
          margin-bottom: 21px;
        }
        .comment-item-userinfo {
          height: 20px;
          font-size: 14px;
          font-weight: bold;
          line-height: 20px;
          color: #16cfd0;
        }
        .comment-item-icon {
          position: absolute;
          right: 58px;
          bottom: -20px;
        }
      }
    }
  }
}
.ques-section {
  height: 624px;
  padding-top: 80px;
  background-color: #fff;
  .ques-tab {
    display: flex;
    justify-content: center;
    margin-bottom: 65px;
    .ques-tab-item {
      width: 135px;
      font-size: 18px;
      text-align: center;
      color: #7d7e7d;
      cursor: pointer;
    }
    .active {
      color: #000;
      font-weight: bold;
    }
  }
  .ques-ans {
    h3 {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 20px;
    }
    p {
      font-size: 14px;
      line-height: 21px;
    }
  }
}
.teachers-section {
  height: 615px;
  background: #f7f7f7;
  padding-top: 95px;
  .teachers-container {
    width: 1170px;
    margin: 0px auto;
    position: relative;
    .teachers-title {
      height: 64px;
      font-size: 48px;
      line-height: 64px;
      color: #333333;
      margin-bottom: 48px;
    }
    .teachers-content {
      display: flex;
      justify-content: space-between;
      .teachers-item {
        width: 272px;
        height: 312px;
        padding-top: 20px;
        background: #ffffff;
        .teachers-item-image-border {
          width: 208px;
          height: 208px;
          margin: 0px auto 0px auto;
          background: linear-gradient(
            271deg,
            #16cfd0 0%,
            #16cfd0 0%,
            #04a7fc 100%
          );
          border-radius: 208px;
          display: flex;
          align-items: center;
          justify-content: center;
          .teachers-item-image {
            width: 200px;
            height: 200px;
            background-color: #fff;
            border-radius: 200px;
            margin: 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 192px;
              height: 192px;
              margin: 0;
              border-radius: 192px;
            }
          }
        }
        .teacher-item-name {
          margin-top: 12px;
          height: 21px;
          line-height: 21px;
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          color: #333333;
        }
        .teacher-item-job {
          margin-top: 4px;
          height: 19px;
          line-height: 19px;
          font-size: 14px;
          text-align: center;
          color: #16cfd0;
        }
      }
    }
  }
}
.contact-section {
  background-image: url('../../assets/img/contact/contact-bg.png');
  background-size: auto 100%;
  min-height: 600px;
  padding-top: 64px;
  .contact-container {
    width: 1170px;
    margin: 0px auto;
    display: flex;
    align-items: center;
    .contact-info {
      width: 584px;
      .contact-title {
        height: 61px;
        font-size: 46px;
        font-weight: bold;
        line-height: 61px;
        color: #ffffff;
        margin-bottom: 51px;
      }
      .contact-row {
        width: 520px;
        padding-bottom: 16px;
        margin-bottom: 16px;
        border-bottom: 1px solid #2681ba;
        display: flex;
        flex-direction: column;
        &:last-child {
          border-bottom: 0px;
        }
        .contact-item {
          display: flex;
          align-items: center;
          .contact-icon {
            width: 64px;
            height: 64px;
            margin-right: 16px;
            background-image: url('../../assets/img/contact/icon-bg.png');
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .contact-text {
            width: 440px;
            font-size: 18px;
            line-height: 28px;
            color: #ffffff;
          }
        }
      }
    }
    .contact-map {
      width: 610px;
      height: 442px;
      position: relative;
      iframe {
        position: absolute;
        top: 0;
        left: 10px;
        width: 600px;
        height: 442px;
      }
    }
  }
}
.about-section {
  padding: 80px 0 0 0;
  .about-container {
    width: 1170px;
    margin: 0px auto;
    display: flex;
    justify-content: space-between;
    .about-title {
      height: 40px;
      font-size: 30px;
      font-weight: 500;
      line-height: 40px;
      color: #333333;
      position: relative;
      margin-bottom: 48px;
    }
    .about-title:after {
      content: '';
      position: absolute;
      top: 56px;
      height: 2px;
      width: 64px;
      left: 0;
      background-color: #17d0cf;
    }
    .about-info {
      width: 408px;
      .about-logo {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        img {
          width: 48px;
          height: 48px;
          margin-right: 8px;
        }
        .about-logo-title {
          height: 26px;
          font-size: 20px;
          line-height: 26px;
          color: #000000;
        }
        .about-logo-authority {
          margin-top: 3px;
          height: 19px;
          font-size: 14px;
          line-height: 19px;
          color: #000000;
        }
      }
      .about-desc {
        font-size: 16px;
        line-height: 24px;
        color: #000000;
        text-indent: 32px;
      }
    }
    .about-link {
      .about-link-item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .about-link-icon {
          margin-right: 8px;
        }
        .about-link-text {
          height: 21px;
          line-height: 21px;
          font-size: 16px;
          color: #333333;
          cursor: pointer;
        }
      }
    }
    .about-weixin {
      img {
        width: 272px;
      }
    }
  }
}
.login-module {
  position: absolute;
  top: 112px;
  right: 15px;
  width: 400px;
  height: 310px;
  padding: 16px 32px 0 32px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 4px;
}
.login-module-title {
  margin-top: 14px;
  font-size: 20px;
  line-height: 24px;
  color: #ffffff;
}
.login-module-content {
  height: 170px;
  padding-top: 30px;
  font-size: 20px;
  color: #fff;
}
.login-module .login-form {
  margin: 16px 0;
}
.login-btn-row {
  display: flex;
  justify-content: space-between;
}
.login-btn-qyzc {
  background: transparent;
  width: 120px;
  height: 50px;
  font-size: 16px;
  color: #16cfd0;
  border-color: #16cfd0;
}
.login-wjmm {
  color: #16cfd0;
  margin-top: 8px;
  text-align: right;
  cursor: pointer;
}
.yanzhenma {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  position: absolute;
  right: -100px;
  top: 5px;
  a {
    color: #16cfd0;
    padding: 0px;
    padding-bottom: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    &.disabled {
      color: #9fabab !important;
      cursor: not-allowed;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    span {
      width: 64px;
    }
  }
}
</style>
<style scoped>
.comment-content >>> .owl-prev,
.comment-content >>> .owl-next {
  background-color: #3080b6;
  color: #f7f7f7;
}
.teachers-content >>> .owl-prev,
.teachers-content >>> .owl-next {
  background-color: #fff;
  color: #777777;
}
.login-module >>> .el-tabs__item {
  padding: 0;
  font-family: 'Microsoft YaHei';
  font-size: 16px;
  font-weight: 400;
  width: 112px;
  text-align: center;
  color: #fff;
}
.login-module >>> .el-tabs__item:hover {
  color: #fff;
  cursor: pointer;
}
.login-module >>> .el-tabs__item.is-active {
  color: #fff;
}
.login-module >>> .el-tabs__active-bar {
  background-color: #2bcecf;
}
</style>



// WEBPACK FOOTER //
// src/views/home/content.vue